
var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return n(r, t, e, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return n(r, t, e, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return n(r, t, e, a, u, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(r, t, e, a, u, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, a) {
        return 4 === n.a ? n.f(r, t, e, a) : n(r)(t)(e)(a);
    }
    function A5(n, r, t, e, a, u) {
        return 5 === n.a ? n.f(r, t, e, a, u) : n(r)(t)(e)(a)(u);
    }
    function A8(n, r, t, e, a, u, i, c, o) {
        return 8 === n.a ? n.f(r, t, e, a, u, i, c, o) : n(r)(t)(e)(a)(u)(i)(c)(o);
    }
    var t = {
        $: 0
    };
    function e(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var a = F2(e);
    function u(n) {
        for(var r = t, a = n.length; a--;)r = e(n[a], r);
        return r;
    }
    var i = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return u(e);
    }), c = F3(function(n, r, t) {
        for(var e = Array(n), a = 0; n > a; a++)e[a] = t(r + a);
        return e;
    }), o = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, p(t, r);
    });
    function f(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function s(n, r) {
        for(var t, e = [], a = l(n, r, 0, e); a && (t = e.pop()); a = l(t.a, t.b, 0, e));
        return a;
    }
    function l(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && f(5), !1;
        if (t > 100) return e.push(p(n, r)), !0;
        for(var a in 0 > n.$ && (n = Un(n), r = Un(r)), n)if (!l(n[a], r[a], t + 1, e)) return !1;
        return !0;
    }
    function b(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = b(n.a, r.a)) || (t = b(n.b, r.b)) ? t : b(n.c, r.c);
        for(; n.b && r.b && !(t = b(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var d = F2(function(n, r) {
        var t = b(n, r);
        return 0 > t ? Wn : t ? Xn : Zn;
    });
    function p(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function v(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function h(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function g(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = e(n.a, r);
        n = n.b;
        for(var a = t; n.b; n = n.b)a = a.b = e(n.a, r);
        return t;
    }
    var m = F2(function(n, r) {
        return n + r;
    }), $ = Math.ceil, w = Math.floor, x = Math.round, y = Math.log, k = F2(function(n, r) {
        return r.join(n);
    });
    function j(n) {
        return n + "";
    }
    function z(n) {
        return {
            $: 2,
            b: n
        };
    }
    var E = z(function(n) {
        return "number" != typeof n ? I("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? ur(n) : !isFinite(n) || n % 1 ? I("an INT", n) : ur(n);
    }), B = (z(function(n) {
        return "boolean" == typeof n ? ur(n) : I("a BOOL", n);
    }), z(function(n) {
        return "number" == typeof n ? ur(n) : I("a FLOAT", n);
    }), z(function(n) {
        return ur(n);
    }), z(function(n) {
        return "string" == typeof n ? ur(n) : n instanceof String ? ur(n + "") : I("a STRING", n);
    })), F = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    var A = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), _ = F2(function(n, r) {
        return function(n, r) {
            return {
                $: 9,
                f: n,
                g: r
            };
        }(n, [
            r
        ]);
    }), L = F2(function(n, r) {
        return S(n, r);
    });
    function S(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? ur(n.c) : I("null", r);
            case 3:
                return K(r) ? N(n.b, r, u) : I("a LIST", r);
            case 4:
                return K(r) ? N(n.b, r, P) : I("an ARRAY", r);
            case 6:
                var a = n.d;
                if ("object" != typeof r || null === r || !(a in r)) return I("an OBJECT with a field named `" + a + "`", r);
                var i = S(n.b, r[a]);
                return qr(i) ? i : rr(A2(er, a, i.a));
            case 7:
                var c = n.e;
                return K(r) ? r.length > c ? (i = S(n.b, r[c]), qr(i) ? i : rr(A2(ar, c, i.a))) : I("a LONGER array. Need index " + c + " but only see " + r.length + " entries", r) : I("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || K(r)) return I("an OBJECT", r);
                var o = t;
                for(var f in r)if (r.hasOwnProperty(f)) {
                    if (i = S(n.b, r[f]), !qr(i)) return rr(A2(er, f, i.a));
                    o = e(p(f, i.a), o);
                }
                return ur(mr(o));
            case 9:
                for(var s = n.f, l = n.g, b = 0; l.length > b; b++){
                    if (i = S(l[b], r), !qr(i)) return i;
                    s = s(i.a);
                }
                return ur(s);
            case 10:
                return i = S(n.b, r), qr(i) ? S(n.h(i.a), r) : i;
            case 11:
                for(var d = t, v = n.g; v.b; v = v.b){
                    if (i = S(v.a, r), qr(i)) return i;
                    d = e(i.a, d);
                }
                return rr(ir(mr(d)));
            case 1:
                return rr(A2(tr, n.a, r));
            case 0:
                return ur(n.a);
        }
    }
    function N(n, r, t) {
        for(var e = r.length, a = Array(e), u = 0; e > u; u++){
            var i = S(n, r[u]);
            if (!qr(i)) return rr(A2(ar, u, i.a));
            a[u] = i.a;
        }
        return ur(t(a));
    }
    function K(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function P(n) {
        return A2(Or, n.length, function(r) {
            return n[r];
        });
    }
    function I(n, r) {
        return rr(A2(tr, "Expecting " + n, r));
    }
    function O(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return O(n.b, r.b);
            case 6:
                return n.d === r.d && O(n.b, r.b);
            case 7:
                return n.e === r.e && O(n.b, r.b);
            case 9:
                return n.f === r.f && q(n.g, r.g);
            case 10:
                return n.h === r.h && O(n.b, r.b);
            case 11:
                return q(n.g, r.g);
        }
    }
    function q(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!O(n[e], r[e])) return !1;
        return !0;
    }
    function M(n) {
        return n;
    }
    var T = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function G(n) {
        return {
            $: 0,
            a: n
        };
    }
    function C(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var D = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Q = 0;
    function J(n) {
        var r = {
            $: 0,
            e: Q++,
            f: n,
            g: null,
            h: []
        };
        return Z(r), r;
    }
    var R = !1, H = [];
    function Z(n) {
        if (H.push(n), !R) {
            for(R = !0; n = H.shift();)W(n);
            R = !1;
        }
    }
    function W(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Z(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var Y = {};
    function V(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, a = n.d, u = n.e, i = n.f;
        function c(n) {
            return A2(D, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(a, t, c, n) : u && i ? A4(e, t, c.i, c.j, n) : A3(e, t, u ? c.i : c.j, n);
                }
            });
        }
        return t.h = J(A2(D, c, n.b));
    }
    var U = F2(function(n, r) {
        return C(function(t) {
            n.g(r), t(G(0));
        });
    });
    function X(n) {
        return {
            $: 2,
            m: n
        };
    }
    var nn, rn = [], tn = !1;
    function en(n, r, t) {
        if (rn.push({
            p: n,
            q: r,
            r: t
        }), !tn) {
            tn = !0;
            for(var e; e = rn.shift();)an(e.p, e.q, e.r);
            tn = !1;
        }
    }
    function an(n, r, e) {
        var a, u = {};
        for(var i in un(!0, r, u, null), un(!1, e, u, null), n)(a = n[i]).h.push({
            $: "fx",
            a: u[i] || {
                i: t,
                j: t
            }
        }), Z(a);
    }
    function un(n, r, a, u) {
        switch(r.$){
            case 1:
                var i = r.k, c = function(n, r, t, e) {
                    function a(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Y[r].e : Y[r].f, a, e);
                }(n, i, u, r.l);
                return void (a[i] = function(n, r, a) {
                    return a = a || {
                        i: t,
                        j: t
                    }, n ? a.i = e(r, a.i) : a.j = e(r, a.j), a;
                }(n, c, a[i]));
            case 2:
                for(var o = r.m; o.b; o = o.b)un(n, o.a, a, u);
                return;
            case 3:
                return void un(n, r.o, a, {
                    s: r.n,
                    t: u
                });
        }
    }
    var cn = "undefined" != typeof document ? document : {};
    function on(n, r) {
        n.appendChild(r);
    }
    function fn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var sn, ln = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: yn(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), bn = ln(void 0), dn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: yn(t),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0), pn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), vn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), hn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), gn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), mn = /^script$/i, $n = /^(on|formAction$)/i, wn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function xn(n) {
        return mn.test(n) ? "p" : n;
    }
    function yn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, a = t.n, u = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === a ? kn(i, a, u) : i[a] = u;
            } else "className" === a ? kn(r, a, u) : r[a] = u;
        }
        return r;
    }
    function kn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function jn(n, r) {
        var t = n.$;
        if (5 === t) return jn(n.k || (n.k = n.m()), r);
        if (0 === t) return cn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, a = n.j; 4 === e.$;)"object" != typeof a ? a = [
                a,
                e.j
            ] : a.push(e.j), e = e.k;
            var u = {
                j: a,
                p: r
            };
            return (i = jn(e, u)).elm_event_node_ref = u, i;
        }
        if (3 === t) return zn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? cn.createElementNS(n.f, n.c) : cn.createElement(n.c);
        nn && "a" == n.c && i.addEventListener("click", nn(i)), zn(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)on(i, jn(1 === t ? c[o] : c[o].b, r));
        return i;
    }
    function zn(n, r, t) {
        for(var e in t){
            var a = t[e];
            "a1" === e ? En(n, a) : "a0" === e ? An(n, r, a) : "a3" === e ? Bn(n, a) : "a4" === e ? Fn(n, a) : ("value" !== e && "checked" !== e || n[e] !== a) && (n[e] = a);
        }
    }
    function En(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Bn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Fn(n, r) {
        for(var t in r){
            var e = r[t], a = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(a, t, u) : n.removeAttributeNS(a, t);
        }
    }
    function An(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var u = t[a], i = e[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = _n(r, u), n.addEventListener(a, i, sn && {
                    passive: 2 > Cr(u)
                }), e[a] = i;
            } else n.removeEventListener(a, i), e[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                sn = !0;
            }
        }));
    } catch (n) {}
    function _n(n, r) {
        function t(r) {
            var e = t.q, a = S(e.a, r);
            if (qr(a)) {
                for(var u, i = Cr(e), c = a.a, o = i ? 3 > i ? c.a : c.Z : c, f = 1 == i ? c.b : 3 == i && c.bB, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.bv) && r.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) o = u(o);
                    else for(var l = u.length; l--;)o = u[l](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Ln(n, r) {
        return n.$ == r.$ && O(n.a, r.a);
    }
    function Sn(n, r, t, e) {
        var a = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function Nn(n, r, t, e) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Sn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), a = 0; t > a; a++)e[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Nn(n.k, r.k, s, 0), void (s.length > 0 && Sn(t, 1, e, s));
                case 4:
                    for(var l = n.j, b = r.j, d = !1, p = n.k; 4 === p.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        p.j
                    ] : l.push(p.j), p = p.k;
                    for(var v = r.k; 4 === v.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        v.j
                    ] : b.push(v.j), v = v.k;
                    return d && l.length !== b.length ? void Sn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, b) : l === b) || Sn(t, 2, e, b), void Nn(p, v, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Sn(t, 3, e, r.a));
                case 1:
                    return void Kn(n, r, t, e, In);
                case 2:
                    return void Kn(n, r, t, e, On);
                case 3:
                    if (n.h !== r.h) return void Sn(t, 0, e, r);
                    var h = Pn(n.d, r.d);
                    h && Sn(t, 4, e, h);
                    var g = r.i(n.g, r.g);
                    return void (g && Sn(t, 5, e, g));
            }
        }
    }
    function Kn(n, r, t, e, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = Pn(n.d, r.d);
            u && Sn(t, 4, e, u), a(n, r, t, e);
        } else Sn(t, 0, e, r);
    }
    function Pn(n, r, t) {
        var e;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === t && Ln(u, i) || ((e = e || {})[a] = i);
            } else (e = e || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var c = Pn(n[a], r[a] || {}, a);
            c && ((e = e || {})[a] = c);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function In(n, r, t, e) {
        var a = n.e, u = r.e, i = a.length, c = u.length;
        i > c ? Sn(t, 6, e, {
            v: c,
            i: i - c
        }) : c > i && Sn(t, 7, e, {
            v: i,
            e: u
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = a[f];
            Nn(s, u[f], t, ++e), e += s.b || 0;
        }
    }
    function On(n, r, t, e) {
        for(var a = [], u = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, l = 0, b = 0, d = e; f > l && s > b;){
            var p = (E = c[l]).a, v = (B = o[b]).a, h = E.b, g = B.b, m = void 0, $ = void 0;
            if (p !== v) {
                var w = c[l + 1], x = o[b + 1];
                if (w) {
                    var y = w.a, k = w.b;
                    $ = v === y;
                }
                if (x) {
                    var j = x.a, z = x.b;
                    m = p === j;
                }
                if (m && $) Nn(h, z, a, ++d), Mn(u, a, p, g, b, i), d += h.b || 0, Tn(u, a, p, k, ++d), d += k.b || 0, l += 2, b += 2;
                else if (m) d++, Mn(u, a, v, g, b, i), Nn(h, z, a, d), d += h.b || 0, l += 1, b += 2;
                else if ($) Tn(u, a, p, h, ++d), d += h.b || 0, Nn(k, g, a, ++d), d += k.b || 0, l += 2, b += 1;
                else {
                    if (!w || y !== j) break;
                    Tn(u, a, p, h, ++d), Mn(u, a, v, g, b, i), d += h.b || 0, Nn(k, z, a, ++d), d += k.b || 0, l += 2, b += 2;
                }
            } else Nn(h, g, a, ++d), d += h.b || 0, l++, b++;
        }
        for(; f > l;){
            var E;
            d++, Tn(u, a, (E = c[l]).a, h = E.b, d), d += h.b || 0, l++;
        }
        for(; s > b;){
            var B, F = F || [];
            Mn(u, a, (B = o[b]).a, B.b, void 0, F), b++;
        }
        (a.length > 0 || i.length > 0 || F) && Sn(t, 8, e, {
            w: a,
            x: i,
            y: F
        });
    }
    var qn = "_elmW6BL";
    function Mn(n, r, t, e, a, u) {
        var i = n[t];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: e,
                r: a,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var c = [];
            return Nn(i.z, e, c, i.r), i.r = a, void (i.s.s = {
                w: c,
                A: i
            });
        }
        Mn(n, r, t + qn, e, a, u);
    }
    function Tn(n, r, t, e, a) {
        var u = n[t];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return Nn(e, u.z, i, a), void Sn(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            Tn(n, r, t + qn, e, a);
        } else {
            var c = Sn(r, 9, a, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: a,
                s: c
            };
        }
    }
    function Gn(n, r, t, e) {
        Cn(n, r, t, 0, 0, r.b, e);
    }
    function Cn(n, r, t, e, a, u, i) {
        for(var c = t[e], o = c.r; o === a;){
            var f = c.$;
            if (1 === f) Gn(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && Cn(n, r, s, 0, a, u, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, l = c.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Cn(n, r, s, 0, a, u, i));
            } else c.t = n, c.u = i;
            if (!(c = t[++e]) || (o = c.r) > u) return e;
        }
        var b = r.$;
        if (4 === b) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return Cn(n, d, t, e, a + 1, u, n.elm_event_node_ref);
        }
        for(var p = r.e, v = n.childNodes, h = 0; p.length > h; h++){
            a++;
            var g = 1 === b ? p[h] : p[h].b, m = a + (g.b || 0);
            if (!(a > o || o > m || (c = t[e = Cn(v[h], g, t, e, a, m, i)]) && (o = c.r) <= u)) return e;
            a = m;
        }
        return e;
    }
    function Dn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], a = e.t, u = Qn(a, e);
            a === n && (n = u);
        }
        return n;
    }
    function Qn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, a = jn(r, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), e && a !== n && e.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return zn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Dn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, u = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(jn(a[e], r.u), u);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Dn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = cn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var a = n[e].A;
                                on(t, 2 === a.c ? a.s : jn(a.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Dn(n, t.w);
                    for(var a = t.x, u = 0; a.length > u; u++){
                        var i = a[u], c = i.A, o = 2 === c.c ? c.s : jn(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && on(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                f(10);
        }
    }
    function Jn(n) {
        if (3 === n.nodeType) return fn(n.textContent);
        if (1 !== n.nodeType) return fn("");
        for(var r = t, a = n.attributes, u = a.length; u--;){
            var i = a[u];
            r = e(A2(gn, i.name, i.value), r);
        }
        var c = n.tagName.toLowerCase(), o = t, f = n.childNodes;
        for(u = f.length; u--;)o = e(Jn(f[u]), o);
        return A3(bn, c, r, o);
    }
    var Rn = F4(function(n, r, e, a) {
        return function(n, r, t, e, a, u) {
            var i = A2(L, n, r ? r.flags : void 0);
            qr(i) || f(2);
            var c = {}, o = t(i.a), s = o.a, l = u(d, s), b = function(n, r) {
                var t;
                for(var e in Y){
                    var a = Y[e];
                    a.a && ((t = t || {})[e] = a.a(e, r)), n[e] = V(a, r);
                }
                return t;
            }(c, d);
            function d(n, r) {
                var t = A2(e, n, s);
                l(s = t.a, r), en(c, t.b, a(s));
            }
            return en(c, o.b, a(s)), b ? {
                ports: b
            } : {};
        }(r, a, n.dQ, n.e5, n.eK, function(r, e) {
            var a = n.bz && n.bz(r), u = n.e6, i = cn.title, c = cn.body, o = Jn(c);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Hn(e), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === t && (t = 1)) : (0 === t && Hn(e), t = 2);
                };
            }(e, function(n) {
                nn = a;
                var e = u(n), f = bn("body")(t)(e.c9), s = function(n, r) {
                    var t = [];
                    return Nn(n, r, t, 0), t;
                }(o, f);
                c = function(n, r, t, e) {
                    return 0 === t.length ? n : (Gn(n, r, t, e), Dn(n, t));
                }(c, o, s, r), o = f, nn = 0, i !== e.e0 && (cn.title = i = e.e0);
            });
        });
    }), Hn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Zn = 1, Wn = 0, Yn = a, Vn = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, a = n, u = A3(n, t.b, t.c, A3(Vn, n, r, t.e));
            n = a, r = u, t = e;
        }
    }), Un = function(n) {
        return A3(Vn, F3(function(n, r, t) {
            return A2(Yn, p(n, r), t);
        }), t, n);
    }, Xn = 2, nr = {
        $: 0
    }, rr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), er = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ar = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ur = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ir = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cr = m, or = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fr = {
        $: 1
    }, sr = j, lr = F2(function(n, r) {
        return A2(k, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), br = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, a = n, u = A2(n, t.a, r);
            n = a, r = u, t = e;
        }
    }), dr = function(n) {
        return A3(br, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, pr = i, vr = F3(function(n, r, t) {
        for(;;){
            if (b(n, r) >= 1) return t;
            var e = n, a = r - 1, u = A2(Yn, r, t);
            n = e, r = a, t = u;
        }
    }), hr = F2(function(n, r) {
        return A3(vr, n, r, t);
    }), gr = F2(function(n, r) {
        return A3(pr, n, A2(hr, 0, dr(r) - 1), r);
    }), mr = function(n) {
        return A3(br, Yn, t, n);
    }, $r = 32, wr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), xr = [], yr = $, kr = F2(function(n, r) {
        return y(r) / y(n);
    }), jr = function(n) {
        return n;
    }, zr = yr(A2(kr, 2, $r)), Er = A4(wr, 0, zr, xr, xr), Br = c, Fr = w, Ar = function(n) {
        return n.length;
    }, _r = F2(function(n, r) {
        return b(n, r) > 0 ? n : r;
    }), Lr = o, Sr = F2(function(n, r) {
        for(;;){
            var t = A2(Lr, $r, n), e = t.b, a = A2(Yn, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return mr(a);
            n = e, r = a;
        }
    }), Nr = function(n) {
        return n.a;
    }, Kr = F2(function(n, r) {
        for(;;){
            var e = yr(r / $r);
            if (1 === e) return A2(Lr, $r, n).a;
            n = A2(Sr, n, t), r = e;
        }
    }), Pr = F2(function(n, r) {
        if (r.j) {
            var t = r.j * $r, e = Fr(A2(kr, $r, t - 1)), a = n ? mr(r.m) : r.m, u = A2(Kr, a, r.j);
            return A4(wr, Ar(r.l) + t, A2(_r, 5, e * zr), u, r.l);
        }
        return A4(wr, Ar(r.l), zr, xr, r.l);
    }), Ir = F5(function(n, r, t, e, a) {
        for(;;){
            if (0 > r) return A2(Pr, !1, {
                m: e,
                j: t / $r | 0,
                l: a
            });
            var u = {
                $: 1,
                a: A3(Br, $r, r, n)
            };
            r -= $r, e = A2(Yn, u, e);
        }
    }), Or = F2(function(n, r) {
        if (n > 0) {
            var e = n % $r;
            return A5(Ir, r, n - e - $r, n, t, A3(Br, e, n - e, r));
        }
        return Er;
    }), qr = function(n) {
        return !n.$;
    }, Mr = A, Tr = _, Gr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cr = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Dr = function(n) {
        return n;
    }, Qr = G, Jr = Qr(0), Rr = F4(function(n, r, t, e) {
        if (e.b) {
            var a = e.a, u = e.b;
            if (u.b) {
                var i = u.a, c = u.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, a, A2(n, i, A2(n, o, A2(n, f.a, t > 500 ? A3(br, n, r, mr(s)) : A4(Rr, n, r, t + 1, s)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, o, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), Hr = F3(function(n, r, t) {
        return A4(Rr, n, r, 0, t);
    }), Zr = F2(function(n, r) {
        return A3(Hr, F2(function(r, t) {
            return A2(Yn, n(r), t);
        }), t, r);
    }), Wr = D, Yr = F2(function(n, r) {
        return A2(Wr, function(r) {
            return Qr(n(r));
        }, r);
    }), Vr = F3(function(n, r, t) {
        return A2(Wr, function(r) {
            return A2(Wr, function(t) {
                return Qr(A2(n, r, t));
            }, t);
        }, r);
    }), Ur = U, Xr = F2(function(n, r) {
        var t = r;
        return function(n) {
            return C(function(r) {
                r(G(J(n)));
            });
        }(A2(Wr, Ur(n), t));
    });
    Y.Task = {
        b: Jr,
        c: F3(function(n, r) {
            var e;
            return A2(Yr, function() {
                return 0;
            }, (e = A2(Zr, Xr(n), r), A3(Hr, Vr(Yn), Qr(t), e)));
        }),
        d: F3(function() {
            return Qr(0);
        }),
        e: F2(function(n, r) {
            return A2(Yr, n, r);
        }),
        f: undefined
    };
    var nt, rt, tt, et, at, ut, it, ct, ot = Rn, ft = F, st = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lt = function(n) {
        var r = n.b;
        return A2(st, 1664525 * n.a + r >>> 0, r);
    }, bt = function(n) {
        var r = lt(A2(st, 0, 1013904223));
        return lt(A2(st, r.a + n >>> 0, r.b));
    }, dt = E, pt = X, vt = pt(t), ht = X, gt = ht(t), mt = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), $t = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), wt = F4(function(n, r, t, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), xt = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), yt = F3(function(n, r, t) {
        return n(r(t));
    }), kt = function(n) {
        return !n;
    }, jt = F2(function(n, r) {
        return !A2(xt, A2(yt, kt, n), r);
    }), zt = function(n) {
        return n ? 1 : -1;
    }, Et = function(n) {
        return A3(br, cr, 0, n);
    }, Bt = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(Yn, t, n), r -= 1;
        }
    }), Ft = F2(function(n, r) {
        return A3(Bt, t, n, r);
    }), At = F2(function(n, r) {
        if (r.at) return r;
        var e, a = function(n) {
            return A2(Zr, function(r) {
                var t = n._ + Et(A3(pr, F2(function(n, r) {
                    return zt(n) * r;
                }), r.S, n.ay)), e = (zt(r.aF) - t) * n.aO;
                return {
                    bo: A2(Zr, function(n) {
                        return zt(n) * e;
                    }, r.S),
                    bs: e
                };
            }, n.ae);
        }(r), u = dr(r.ae), i = A2(Zr, function(n) {
            return Et(n) / u;
        }, (e = A2(Zr, function(n) {
            return n.bo;
        }, a), A3(Hr, pr(Yn), A2(Ft, function(n) {
            return n.b ? dr(n.a) : 0;
        }(e), t), e))), c = A3(pr, cr, r.ay, i), o = Et(A2(Zr, function(n) {
            return n.bs;
        }, a)) / u;
        return h(r, {
            at: r.at || 0 > b(o, n.bD) && A2(jt, function(r) {
                return 0 > b(r, n.bD);
            }, i),
            _: r._ + o,
            ay: c
        });
    }), _t = F2(function(n, r) {
        return A2(F2(function(r, t) {
            for(;;){
                if (t.at) return t;
                if (r > 5e3) return t;
                r += 1, t = A2(At, n, t);
            }
        }), 0, r);
    }), Lt = F3(function(n, r, t) {
        for(;;){
            if (0 >= n) return t;
            var e = n - 1, a = r, u = A2(At, r, t);
            n = e, r = a, t = u;
        }
    }), St = F2(function(n, r) {
        return r.b ? A3(Hr, Yn, r, n) : n;
    }), Nt = j, Kt = F2(function(n, r) {
        for(;;){
            if (!n.b) return or(mr(r));
            var t = n.a;
            if (t.$) return fr;
            n = n.b, r = A2(Yn, t.a, r);
        }
    }), Pt = function(n) {
        return A2(Kt, n, t);
    }, It = function(n) {
        return 0 > n ? -n : n;
    }, Ot = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, qt = F2(function(n, r) {
        return function(t) {
            var e = lt(t), a = It(r - n), u = Ot(e);
            return p((1 * (67108863 & Ot(t)) * 134217728 + 1 * (134217727 & u)) / 9007199254740992 * a + n, lt(e));
        };
    }), Mt = F2(function(n, r) {
        return r.$ ? fr : or(n(r.a));
    }), Tt = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? fr : or(A2(n, r.a, t.a));
    }), Gt = F3(function(n, r, t) {
        var e = r, a = t;
        return function(r) {
            var t = e(r), u = t.a, i = a(t.b), c = i.b;
            return p(A2(n, u, i.a), c);
        };
    }), Ct = function(n) {
        return n.b ? or(A3(br, _r, n.a, n.b)) : fr;
    }, Dt = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Qt = function(n) {
        return A2(Dt, 0, Ct(A2(Zr, function(n) {
            return dr(n.S);
        }, n.ae)));
    }, Jt = A2(Hr, Gt(Yn), (nt = t, function(n) {
        return p(nt, n);
    })), Rt = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Ht = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Yn, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Zt = F2(function(n, r) {
        return mr(A3(Ht, n, r, t));
    }), Wt = F3(function(n, r, e) {
        if (r > 0) {
            var a = p(r, e);
            n: for(;;){
                r: for(;;){
                    if (!a.b.b) return e;
                    if (!a.b.b.b) {
                        if (1 === a.a) break n;
                        break r;
                    }
                    switch(a.a){
                        case 1:
                            break n;
                        case 2:
                            var i = a.b;
                            return u([
                                i.a,
                                i.b.a
                            ]);
                        case 3:
                            if (a.b.b.b.b) {
                                var c = a.b, o = c.b;
                                return u([
                                    c.a,
                                    o.a,
                                    o.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (a.b.b.b.b && a.b.b.b.b.b) {
                                var f = a.b, s = f.b, l = s.b, b = l.b, d = b.b;
                                return A2(Yn, f.a, A2(Yn, s.a, A2(Yn, l.a, A2(Yn, b.a, n > 1e3 ? A2(Zt, r - 4, d) : A3(Wt, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return e;
            }
            return u([
                a.b.a
            ]);
        }
        return t;
    }), Yt = F2(function(n, r) {
        return A3(Wt, 0, n, r);
    }), Vt = F2(function(n, r) {
        if (0 > n) return r;
        var t = A2(Rt, n, r);
        if (t.b) {
            var e = t.b;
            return g(A2(Yt, n, r), e);
        }
        return r;
    }), Ut = F2(function(n, r) {
        return n(r);
    }), Xt = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, vt);
            case 1:
                if (r.g.$) return p(r, vt);
                var t = {
                    ae: u([
                        {
                            aF: fr,
                            S: u([
                                fr
                            ])
                        }
                    ]),
                    aO: .2
                }, e = {
                    bD: 1e-8
                };
                return p(h(r, {
                    g: A3($t, Nt(.2), e, t)
                }), vt);
            case 2:
                var a = n.a, i = r.g;
                if (1 !== i.$) return p(r, vt);
                var c = i.a, o = i.b, f = i.c;
                switch(a.$){
                    case 0:
                        var s = {
                            aF: fr,
                            S: A2(Ft, Qt(f), fr)
                        }, l = h(f, {
                            ae: A2(St, f.ae, u([
                                s
                            ]))
                        });
                        return p(h(r, {
                            g: A3($t, c, o, l)
                        }), vt);
                    case 1:
                        return l = h(f, {
                            ae: A2(Vt, b = a.a, f.ae)
                        }), p(h(r, {
                            g: A3($t, c, o, l)
                        }), vt);
                    case 2:
                        return l = h(f, {
                            ae: A2(Zr, function(n) {
                                return h(n, {
                                    S: A2(St, n.S, u([
                                        fr
                                    ]))
                                });
                            }, f.ae)
                        }), p(h(r, {
                            g: A3($t, c, o, l)
                        }), vt);
                    case 3:
                        var b = a.a;
                        return l = h(f, {
                            ae: A2(Zr, function(n) {
                                return h(n, {
                                    S: A2(Vt, b, n.S)
                                });
                            }, f.ae)
                        }), p(h(r, {
                            g: A3($t, c, o, l)
                        }), vt);
                    case 6:
                        var d = function(n) {
                            var r = Jt(A2(Ft, Qt(n), A2(qt, -1, 1))), t = A2(qt, -1, 1), e = Pt(A2(Zr, function(n) {
                                return A3(Tt, F2(function(n, r) {
                                    return {
                                        aF: r,
                                        S: n
                                    };
                                }), Pt(n.S), n.aF);
                            }, n.ae));
                            return A2(Mt, function(e) {
                                return A3(Gt, F2(function(r, t) {
                                    return {
                                        ae: e,
                                        at: !1,
                                        _: t,
                                        ay: r,
                                        aO: n.aO
                                    };
                                }), r, t);
                            }, e);
                        }(f);
                        if (d.$) return p(r, vt);
                        var v = A2(Ut, d.a, r.a3), g = v.b;
                        return p(h(r, {
                            g: A4(wt, !1, o, f, v.a),
                            a3: g
                        }), vt);
                    case 4:
                        return p(h(r, {
                            g: A3($t, c, o, l = a.a)
                        }), vt);
                    default:
                        var m = a.a;
                        return l = (F = function(n) {
                            if (0 === n.length || /[\sxbo]/.test(n)) return fr;
                            var r = +n;
                            return r == r ? or(r) : fr;
                        }(m)).$ ? f : h(f, {
                            aO: F.a
                        }), p(h(r, {
                            g: A3($t, m, o, l)
                        }), vt);
                }
            case 3:
                var $ = n.a, w = r.g;
                if (2 !== w.$) return p(r, vt);
                var x = w.a, y = (o = w.b, w.c), k = w.d;
                switch($.$){
                    case 0:
                        return p(h(r, {
                            g: A4(wt, x, o, y, A3(Lt, $.a, o, k))
                        }), vt);
                    case 1:
                        return p(h(r, {
                            g: A4(wt, x, o, y, A2(_t, o, k))
                        }), vt);
                    case 2:
                        return p(h(r, {
                            g: A4(wt, !x, o, y, k)
                        }), vt);
                    default:
                        if (k.at) {
                            var j = {
                                S: A2(Zr, function(n) {
                                    return {
                                        b6: !0,
                                        cJ: n
                                    };
                                }, (B = k).ay),
                                _: B._
                            };
                            return p(h(r, {
                                g: A3(mt, o, y, j)
                            }), vt);
                        }
                        return p(r, vt);
                }
            default:
                var z = n.a, E = r.g;
                return 3 === E.$ ? (o = E.a, y = E.b, p(h(r, z.$ ? {
                    g: A3($t, Nt(y.aO), o, y)
                } : {
                    g: A3(mt, o, y, z.a)
                }), vt)) : p(r, vt);
        }
        var B, F;
    }), ne = "cx", re = "cy", te = "acb", ee = "accx", ae = "accy", ue = "acr", ie = "al", ce = "ar", oe = "s", fe = "bh", se = "c", le = "ctr", be = "ccy", de = "cl", pe = "cptr", ve = "ctxt", he = "focus-within", ge = "hc", me = "he", $e = "hf", we = "hfp", xe = "fr", ye = "lbl", ke = "imlf", je = "imlp", ze = "implw", Ee = "nb", Be = "notxt", Fe = "ol", Ae = "or", _e = "oq", Le = "pg", Se = "p", Ne = "r", Ke = "e", Pe = "cap", Ie = "t", Oe = "clr", qe = "wc", Me = "we", Te = "wf", Ge = "wfp", Ce = function(n) {
        return {
            $: 1,
            a: n
        };
    }, De = M, Qe = F2(function(n, r) {
        return A2(hn, n, De(r));
    }), Je = Qe("className"), Re = function(n) {
        return Ce(Je(n));
    }, He = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ze = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), We = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ye = {
        $: 0
    }, Ve = {
        $: 0
    }, Ue = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xe = {
        $: 0
    }, na = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ra = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ta = F2(function(n, r) {
        switch(r.$){
            case 0:
                return n;
            case 1:
                return g(r.a, n);
            case 2:
                return g(n, r.a);
            default:
                return g(r.a, g(n, r.b));
        }
    }), ea = F3(function(n, r, t) {
        switch(t.$){
            case 0:
                return r;
            case 1:
                return g(A2(Zr, function(r) {
                    return p(n, r);
                }, t.a), r);
            case 2:
                return g(r, A2(Zr, function(r) {
                    return p(n, r);
                }, e = t.a));
            default:
                var e = t.b;
                return g(A2(Zr, function(r) {
                    return p(n, r);
                }, t.a), g(r, A2(Zr, function(r) {
                    return p(n, r);
                }, e)));
        }
    }), aa = function(n) {
        return n > 31 ? {
            $: 1,
            a: 1 << n - 32
        } : {
            $: 0,
            a: 1 << n
        };
    }, ua = aa(41), ia = aa(40), ca = aa(42), oa = aa(43), fa = bn("div"), sa = {
        $: -2
    }, la = sa, ba = la, da = function(n) {
        switch(n.$){
            case 0:
                return sr(n.a) + "px";
            case 1:
                return "auto";
            case 2:
                return sr(n.a) + "fr";
            case 3:
                var r = n.b;
                return "min" + (sr(n.a) + da(r));
            default:
                return r = n.b, "max" + (sr(n.a) + da(r));
        }
    }, pa = x, va = function(n) {
        return sr(pa(255 * n));
    }, ha = function(n) {
        switch(n.$){
            case 0:
                return fr;
            case 1:
                var r = n.a, t = r.b, e = r.c;
                return or("mv-" + va(r.a) + "-" + va(t) + "-" + va(e));
            default:
                var a = n.a, u = a.b, i = a.c, c = n.b, o = c.a, f = c.b, s = c.c, l = n.c, b = l.a, d = l.b, p = l.c, v = n.d;
                return or("tfrm-" + va(a.a) + "-" + va(u) + "-" + va(i) + "-" + va(o) + "-" + va(f) + "-" + va(s) + "-" + va(b) + "-" + va(d) + "-" + va(p) + "-" + va(v));
        }
    }, ga = function(n) {
        switch(n.$){
            case 13:
            case 1:
            case 12:
                return u = n.a;
            case 0:
            case 3:
            case 4:
            case 5:
            case 7:
            case 6:
                return n.a;
            case 2:
                return "font-size-" + sr(n.a);
            case 8:
                var r = n.a;
                return "grid-rows-" + A2(lr, "-", A2(Zr, da, r.ev)) + "-cols-" + A2(lr, "-", A2(Zr, da, r.Q)) + "-space-x-" + da(r.eE.a) + "-space-y-" + da(r.eE.b);
            case 9:
                var t = n.a;
                return "gp grid-pos-" + sr(t.L) + "-" + sr(t.dp) + "-" + sr(t.cL) + "-" + sr(t.b1);
            case 11:
                var e = n.a, a = n.b, u = function() {
                    switch(e){
                        case 0:
                            return "fs";
                        case 1:
                            return "hv";
                        default:
                            return "act";
                    }
                }();
                return A2(lr, " ", A2(Zr, function(n) {
                    var r = ga(n);
                    return "" === r ? "" : r + "-" + u;
                }, a));
            default:
                return A2(Dt, "", ha(n.a));
        }
    }, ma = F5(function(n, r, t, e, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), $a = F5(function(n, r, t, e, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(ma, n, r, t, e, a);
            var u = e.d;
            return i = e.e, A5(ma, 0, e.b, e.c, A5(ma, 1, u.b, u.c, u.d, u.e), A5(ma, 1, r, t, i, a));
        }
        var i, c = a.b, o = a.c, f = a.d, s = a.e;
        return -1 !== e.$ || e.a ? A5(ma, n, c, o, A5(ma, 0, r, t, e, f), s) : A5(ma, 0, r, t, A5(ma, 1, e.b, e.c, e.d, i = e.e), A5(ma, 1, c, o, f, s));
    }), wa = d, xa = F3(function(n, r, t) {
        if (-2 === t.$) return A5(ma, 0, n, r, sa, sa);
        var e = t.a, a = t.b, u = t.c, i = t.d, c = t.e;
        switch(A2(wa, n, a)){
            case 0:
                return A5($a, e, a, u, A3(xa, n, r, i), c);
            case 1:
                return A5(ma, e, a, r, i, c);
            default:
                return A5($a, e, a, u, i, A3(xa, n, r, c));
        }
    }), ya = F3(function(n, r, t) {
        var e = A3(xa, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(ma, 1, e.b, e.c, e.d, e.e);
    }), ka = F2(function(n, r) {
        return A3(ya, n, 0, r);
    }), ja = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return fr;
            var t = r.c, e = r.d, a = r.e;
            switch(A2(wa, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return or(t);
                default:
                    r = a;
                    continue n;
            }
        }
    }), za = F2(function(n, r) {
        return !A2(ja, n, r).$;
    }), Ea = F2(function(n, r) {
        return A2(za, n, r);
    }), Ba = F2(function(n, r) {
        var t = r.a, e = r.b, a = ga(n);
        return A2(Ea, a, t) ? r : p(A2(ka, a, t), A2(Yn, n, e));
    }), Fa = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Aa = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _a = function(n) {
        return "." + n;
    }, La = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Yn, e.a, t);
    }), Sa = F2(function(n, r) {
        return A3(Hr, La(n), t, r);
    }), Na = function(n) {
        var r = n.b, t = n.c, e = n.d;
        return "rgba(" + sr(pa(255 * n.a)) + "," + sr(pa(255 * r)) + "," + sr(pa(255 * t)) + "," + Nt(e) + ")";
    }, Ka = function(n) {
        return A2(lr, " ", A2(Sa, Dr, u([
            n.b7 ? or("inset") : fr,
            or(Nt(n.cj.a) + "px"),
            or(Nt(n.cj.b) + "px"),
            or(Nt(n.ap) + "px"),
            or(Nt(n.al) + "px"),
            or(Na(n.aq))
        ])));
    }, Pa = F2(function(n, r) {
        var t = r.b;
        return p(n(r.a), t);
    }), Ia = F2(function(n, r) {
        return p(r.a, n(r.b));
    }), Oa = function(n) {
        return u([
            A2(Aa, _a(he) + ":focus-within", A2(Sa, Dr, u([
                A2(Mt, function(n) {
                    return A2(Fa, "border-color", Na(n));
                }, n.db),
                A2(Mt, function(n) {
                    return A2(Fa, "background-color", Na(n));
                }, n.c3),
                A2(Mt, function(n) {
                    return A2(Fa, "box-shadow", Ka({
                        ap: n.ap,
                        aq: n.aq,
                        b7: !1,
                        cj: A2(Ia, jr, A2(Pa, jr, n.cj)),
                        al: n.al
                    }));
                }, n.eA),
                or(A2(Fa, "outline", "none"))
            ]))),
            A2(Aa, _a(oe) + ":focus .focusable, " + _a(oe) + ".focusable:focus, .ui-slide-bar:focus + " + _a(oe) + " .focusable-thumb", A2(Sa, Dr, u([
                A2(Mt, function(n) {
                    return A2(Fa, "border-color", Na(n));
                }, n.db),
                A2(Mt, function(n) {
                    return A2(Fa, "background-color", Na(n));
                }, n.c3),
                A2(Mt, function(n) {
                    return A2(Fa, "box-shadow", Ka({
                        ap: n.ap,
                        aq: n.aq,
                        b7: !1,
                        cj: A2(Ia, jr, A2(Pa, jr, n.cj)),
                        al: n.al
                    }));
                }, n.eA),
                or(A2(Fa, "outline", "none"))
            ])))
        ]);
    }, qa = function(n) {
        return bn(xn(n));
    }, Ma = F2(function(n, r) {
        return A2(hn, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && wn.test(n) ? "" : n;
        }(r));
    }), Ta = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ga = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ca = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Da = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Qa = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ja = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ra = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ha = u([
        0,
        1,
        2,
        3,
        4,
        5
    ]), Za = function(n) {
        return A3(Hr, St, t, n);
    }, Wa = F2(function(n, r) {
        return Za(A2(Zr, n, r));
    }), Ya = function(n) {
        switch(n){
            case 0:
                return _a("ct");
            case 1:
                return _a("cb");
            case 2:
                return _a("cr");
            case 3:
                return _a(de);
            case 4:
                return _a("ccx");
            default:
                return _a(be);
        }
    }, Va = function(n) {
        switch(n){
            case 0:
                return _a("at");
            case 1:
                return _a("ab");
            case 2:
                return _a(ce);
            case 3:
                return _a(ie);
            case 4:
                return _a(ne);
            default:
                return _a(re);
        }
    }, Ua = function(n) {
        return Ga(A2(Wa, function(r) {
            var t = n(r), e = t.a, a = t.b;
            return u([
                A2(Qa, Ya(r), e),
                A2(Ca, _a(oe), u([
                    A2(Qa, Va(r), a)
                ]))
            ]);
        }, Ha));
    }, Xa = u([
        A2(Ja, "display", "flex"),
        A2(Ja, "flex-direction", "column"),
        A2(Ja, "white-space", "pre"),
        A2(Qa, _a("hbh"), u([
            A2(Ja, "z-index", "0"),
            A2(Ca, _a(fe), u([
                A2(Ja, "z-index", "-1")
            ]))
        ])),
        A2(Qa, _a("sbt"), u([
            A2(Ca, _a(Ie), u([
                A2(Qa, _a($e), u([
                    A2(Ja, "flex-grow", "0")
                ])),
                A2(Qa, _a(Te), u([
                    A2(Ja, "align-self", "auto !important")
                ]))
            ]))
        ])),
        A2(Ca, _a(ge), u([
            A2(Ja, "height", "auto")
        ])),
        A2(Ca, _a($e), u([
            A2(Ja, "flex-grow", "100000")
        ])),
        A2(Ca, _a(Te), u([
            A2(Ja, "width", "100%")
        ])),
        A2(Ca, _a(Ge), u([
            A2(Ja, "width", "100%")
        ])),
        A2(Ca, _a(qe), u([
            A2(Ja, "align-self", "flex-start")
        ])),
        Ua(function(n) {
            switch(n){
                case 0:
                    return p(u([
                        A2(Ja, "justify-content", "flex-start")
                    ]), u([
                        A2(Ja, "margin-bottom", "auto !important"),
                        A2(Ja, "margin-top", "0 !important")
                    ]));
                case 1:
                    return p(u([
                        A2(Ja, "justify-content", "flex-end")
                    ]), u([
                        A2(Ja, "margin-top", "auto !important"),
                        A2(Ja, "margin-bottom", "0 !important")
                    ]));
                case 2:
                    return p(u([
                        A2(Ja, "align-items", "flex-end")
                    ]), u([
                        A2(Ja, "align-self", "flex-end")
                    ]));
                case 3:
                    return p(u([
                        A2(Ja, "align-items", "flex-start")
                    ]), u([
                        A2(Ja, "align-self", "flex-start")
                    ]));
                case 4:
                    return p(u([
                        A2(Ja, "align-items", "center")
                    ]), u([
                        A2(Ja, "align-self", "center")
                    ]));
                default:
                    return p(u([
                        A2(Ca, _a(oe), u([
                            A2(Ja, "margin-top", "auto"),
                            A2(Ja, "margin-bottom", "auto")
                        ]))
                    ]), u([
                        A2(Ja, "margin-top", "auto !important"),
                        A2(Ja, "margin-bottom", "auto !important")
                    ]));
            }
        })
    ]), nu = u([
        0,
        1,
        2,
        3,
        4,
        5
    ]), ru = u([
        A2(Da, "html,body", u([
            A2(Ja, "height", "100%"),
            A2(Ja, "padding", "0"),
            A2(Ja, "margin", "0")
        ])),
        A2(Da, g(_a(oe), g(_a(Ke), _a("ic"))), u([
            A2(Ja, "display", "block"),
            A2(Qa, _a($e), u([
                A2(Ca, "img", u([
                    A2(Ja, "max-height", "100%"),
                    A2(Ja, "object-fit", "cover")
                ]))
            ])),
            A2(Qa, _a(Te), u([
                A2(Ca, "img", u([
                    A2(Ja, "max-width", "100%"),
                    A2(Ja, "object-fit", "cover")
                ]))
            ]))
        ])),
        A2(Da, _a(oe) + ":focus", u([
            A2(Ja, "outline", "none")
        ])),
        A2(Da, _a("ui"), u([
            A2(Ja, "width", "100%"),
            A2(Ja, "height", "auto"),
            A2(Ja, "min-height", "100%"),
            A2(Ja, "z-index", "0"),
            A2(Qa, g(_a(oe), _a($e)), u([
                A2(Ja, "height", "100%"),
                A2(Ca, _a($e), u([
                    A2(Ja, "height", "100%")
                ]))
            ])),
            A2(Ca, _a(xe), u([
                A2(Qa, _a(Ee), u([
                    A2(Ja, "position", "fixed"),
                    A2(Ja, "z-index", "20")
                ]))
            ]))
        ])),
        A2(Da, _a(Ee), u([
            A2(Ja, "position", "relative"),
            A2(Ja, "border", "none"),
            A2(Ja, "display", "flex"),
            A2(Ja, "flex-direction", "row"),
            A2(Ja, "flex-basis", "auto"),
            A2(Qa, _a(Ke), Xa),
            Ga((tt = function(n) {
                switch(n){
                    case 0:
                        return A2(Qa, _a("a"), u([
                            A2(Ja, "position", "absolute"),
                            A2(Ja, "bottom", "100%"),
                            A2(Ja, "left", "0"),
                            A2(Ja, "width", "100%"),
                            A2(Ja, "z-index", "20"),
                            A2(Ja, "margin", "0 !important"),
                            A2(Ca, _a($e), u([
                                A2(Ja, "height", "auto")
                            ])),
                            A2(Ca, _a(Te), u([
                                A2(Ja, "width", "100%")
                            ])),
                            A2(Ja, "pointer-events", "none"),
                            A2(Ca, "*", u([
                                A2(Ja, "pointer-events", "auto")
                            ]))
                        ]));
                    case 1:
                        return A2(Qa, _a("b"), u([
                            A2(Ja, "position", "absolute"),
                            A2(Ja, "bottom", "0"),
                            A2(Ja, "left", "0"),
                            A2(Ja, "height", "0"),
                            A2(Ja, "width", "100%"),
                            A2(Ja, "z-index", "20"),
                            A2(Ja, "margin", "0 !important"),
                            A2(Ja, "pointer-events", "none"),
                            A2(Ca, "*", u([
                                A2(Ja, "pointer-events", "auto")
                            ])),
                            A2(Ca, _a($e), u([
                                A2(Ja, "height", "auto")
                            ]))
                        ]));
                    case 2:
                        return A2(Qa, _a(Ae), u([
                            A2(Ja, "position", "absolute"),
                            A2(Ja, "left", "100%"),
                            A2(Ja, "top", "0"),
                            A2(Ja, "height", "100%"),
                            A2(Ja, "margin", "0 !important"),
                            A2(Ja, "z-index", "20"),
                            A2(Ja, "pointer-events", "none"),
                            A2(Ca, "*", u([
                                A2(Ja, "pointer-events", "auto")
                            ]))
                        ]));
                    case 3:
                        return A2(Qa, _a(Fe), u([
                            A2(Ja, "position", "absolute"),
                            A2(Ja, "right", "100%"),
                            A2(Ja, "top", "0"),
                            A2(Ja, "height", "100%"),
                            A2(Ja, "margin", "0 !important"),
                            A2(Ja, "z-index", "20"),
                            A2(Ja, "pointer-events", "none"),
                            A2(Ca, "*", u([
                                A2(Ja, "pointer-events", "auto")
                            ]))
                        ]));
                    case 4:
                        return A2(Qa, _a(xe), u([
                            A2(Ja, "position", "absolute"),
                            A2(Ja, "width", "100%"),
                            A2(Ja, "height", "100%"),
                            A2(Ja, "left", "0"),
                            A2(Ja, "top", "0"),
                            A2(Ja, "margin", "0 !important"),
                            A2(Ja, "pointer-events", "none"),
                            A2(Ca, "*", u([
                                A2(Ja, "pointer-events", "auto")
                            ]))
                        ]));
                    default:
                        return A2(Qa, _a(fe), u([
                            A2(Ja, "position", "absolute"),
                            A2(Ja, "width", "100%"),
                            A2(Ja, "height", "100%"),
                            A2(Ja, "left", "0"),
                            A2(Ja, "top", "0"),
                            A2(Ja, "margin", "0 !important"),
                            A2(Ja, "z-index", "0"),
                            A2(Ja, "pointer-events", "none"),
                            A2(Ca, "*", u([
                                A2(Ja, "pointer-events", "auto")
                            ]))
                        ]));
                }
            }, A2(Zr, tt, nu)))
        ])),
        A2(Da, _a(oe), u([
            A2(Ja, "position", "relative"),
            A2(Ja, "border", "none"),
            A2(Ja, "flex-shrink", "0"),
            A2(Ja, "display", "flex"),
            A2(Ja, "flex-direction", "row"),
            A2(Ja, "flex-basis", "auto"),
            A2(Ja, "resize", "none"),
            A2(Ja, "font-feature-settings", "inherit"),
            A2(Ja, "box-sizing", "border-box"),
            A2(Ja, "margin", "0"),
            A2(Ja, "padding", "0"),
            A2(Ja, "border-width", "0"),
            A2(Ja, "border-style", "solid"),
            A2(Ja, "font-size", "inherit"),
            A2(Ja, "color", "inherit"),
            A2(Ja, "font-family", "inherit"),
            A2(Ja, "line-height", "1"),
            A2(Ja, "font-weight", "inherit"),
            A2(Ja, "text-decoration", "none"),
            A2(Ja, "font-style", "inherit"),
            A2(Qa, _a("wrp"), u([
                A2(Ja, "flex-wrap", "wrap")
            ])),
            A2(Qa, _a(Be), u([
                A2(Ja, "-moz-user-select", "none"),
                A2(Ja, "-webkit-user-select", "none"),
                A2(Ja, "-ms-user-select", "none"),
                A2(Ja, "user-select", "none")
            ])),
            A2(Qa, _a(pe), u([
                A2(Ja, "cursor", "pointer")
            ])),
            A2(Qa, _a(ve), u([
                A2(Ja, "cursor", "text")
            ])),
            A2(Qa, _a("ppe"), u([
                A2(Ja, "pointer-events", "none !important")
            ])),
            A2(Qa, _a("cpe"), u([
                A2(Ja, "pointer-events", "auto !important")
            ])),
            A2(Qa, _a(Oe), u([
                A2(Ja, "opacity", "0")
            ])),
            A2(Qa, _a(_e), u([
                A2(Ja, "opacity", "1")
            ])),
            A2(Qa, _a(g("hv", Oe)) + ":hover", u([
                A2(Ja, "opacity", "0")
            ])),
            A2(Qa, _a(g("hv", _e)) + ":hover", u([
                A2(Ja, "opacity", "1")
            ])),
            A2(Qa, _a(g("fcs", Oe)) + ":focus", u([
                A2(Ja, "opacity", "0")
            ])),
            A2(Qa, _a(g("fcs", _e)) + ":focus", u([
                A2(Ja, "opacity", "1")
            ])),
            A2(Qa, _a(g("atv", Oe)) + ":active", u([
                A2(Ja, "opacity", "0")
            ])),
            A2(Qa, _a(g("atv", _e)) + ":active", u([
                A2(Ja, "opacity", "1")
            ])),
            A2(Qa, _a("ts"), u([
                A2(Ja, "transition", A2(lr, ", ", A2(Zr, function(n) {
                    return n + " 160ms";
                }, u([
                    "transform",
                    "opacity",
                    "filter",
                    "background-color",
                    "color",
                    "font-size"
                ]))))
            ])),
            A2(Qa, _a("sb"), u([
                A2(Ja, "overflow", "auto"),
                A2(Ja, "flex-shrink", "1")
            ])),
            A2(Qa, _a("sbx"), u([
                A2(Ja, "overflow-x", "auto"),
                A2(Qa, _a(Ne), u([
                    A2(Ja, "flex-shrink", "1")
                ]))
            ])),
            A2(Qa, _a("sby"), u([
                A2(Ja, "overflow-y", "auto"),
                A2(Qa, _a(se), u([
                    A2(Ja, "flex-shrink", "1")
                ])),
                A2(Qa, _a(Ke), u([
                    A2(Ja, "flex-shrink", "1")
                ]))
            ])),
            A2(Qa, _a("cp"), u([
                A2(Ja, "overflow", "hidden")
            ])),
            A2(Qa, _a("cpx"), u([
                A2(Ja, "overflow-x", "hidden")
            ])),
            A2(Qa, _a("cpy"), u([
                A2(Ja, "overflow-y", "hidden")
            ])),
            A2(Qa, _a(qe), u([
                A2(Ja, "width", "auto")
            ])),
            A2(Qa, _a("bn"), u([
                A2(Ja, "border-width", "0")
            ])),
            A2(Qa, _a("bd"), u([
                A2(Ja, "border-style", "dashed")
            ])),
            A2(Qa, _a("bdt"), u([
                A2(Ja, "border-style", "dotted")
            ])),
            A2(Qa, _a("bs"), u([
                A2(Ja, "border-style", "solid")
            ])),
            A2(Qa, _a(Ie), u([
                A2(Ja, "white-space", "pre"),
                A2(Ja, "display", "inline-block")
            ])),
            A2(Qa, _a("it"), u([
                A2(Ja, "line-height", "1.05"),
                A2(Ja, "background", "transparent"),
                A2(Ja, "text-align", "inherit")
            ])),
            A2(Qa, _a(Ke), Xa),
            A2(Qa, _a(Ne), u([
                A2(Ja, "display", "flex"),
                A2(Ja, "flex-direction", "row"),
                A2(Ca, _a(oe), u([
                    A2(Ja, "flex-basis", "0%"),
                    A2(Qa, _a(Me), u([
                        A2(Ja, "flex-basis", "auto")
                    ])),
                    A2(Qa, _a("lnk"), u([
                        A2(Ja, "flex-basis", "auto")
                    ]))
                ])),
                A2(Ca, _a($e), u([
                    A2(Ja, "align-self", "stretch !important")
                ])),
                A2(Ca, _a(we), u([
                    A2(Ja, "align-self", "stretch !important")
                ])),
                A2(Ca, _a(Te), u([
                    A2(Ja, "flex-grow", "100000")
                ])),
                A2(Ca, _a(le), u([
                    A2(Ja, "flex-grow", "0"),
                    A2(Ja, "flex-basis", "auto"),
                    A2(Ja, "align-self", "stretch")
                ])),
                A2(Ca, "u:first-of-type." + ue, u([
                    A2(Ja, "flex-grow", "1")
                ])),
                A2(Ca, "s:first-of-type." + ee, u([
                    A2(Ja, "flex-grow", "1"),
                    A2(Ca, _a(ne), u([
                        A2(Ja, "margin-left", "auto !important")
                    ]))
                ])),
                A2(Ca, "s:last-of-type." + ee, u([
                    A2(Ja, "flex-grow", "1"),
                    A2(Ca, _a(ne), u([
                        A2(Ja, "margin-right", "auto !important")
                    ]))
                ])),
                A2(Ca, "s:only-of-type." + ee, u([
                    A2(Ja, "flex-grow", "1"),
                    A2(Ca, _a(re), u([
                        A2(Ja, "margin-top", "auto !important"),
                        A2(Ja, "margin-bottom", "auto !important")
                    ]))
                ])),
                A2(Ca, "s:last-of-type.accx ~ u", u([
                    A2(Ja, "flex-grow", "0")
                ])),
                A2(Ca, "u:first-of-type.acr ~ s." + ee, u([
                    A2(Ja, "flex-grow", "0")
                ])),
                Ua(function(n) {
                    switch(n){
                        case 0:
                            return p(u([
                                A2(Ja, "align-items", "flex-start")
                            ]), u([
                                A2(Ja, "align-self", "flex-start")
                            ]));
                        case 1:
                            return p(u([
                                A2(Ja, "align-items", "flex-end")
                            ]), u([
                                A2(Ja, "align-self", "flex-end")
                            ]));
                        case 2:
                            return p(u([
                                A2(Ja, "justify-content", "flex-end")
                            ]), t);
                        case 3:
                            return p(u([
                                A2(Ja, "justify-content", "flex-start")
                            ]), t);
                        case 4:
                            return p(u([
                                A2(Ja, "justify-content", "center")
                            ]), t);
                        default:
                            return p(u([
                                A2(Ja, "align-items", "center")
                            ]), u([
                                A2(Ja, "align-self", "center")
                            ]));
                    }
                }),
                A2(Qa, _a("sev"), u([
                    A2(Ja, "justify-content", "space-between")
                ])),
                A2(Qa, _a(ye), u([
                    A2(Ja, "align-items", "baseline")
                ]))
            ])),
            A2(Qa, _a(se), u([
                A2(Ja, "display", "flex"),
                A2(Ja, "flex-direction", "column"),
                A2(Ca, _a(oe), u([
                    A2(Ja, "flex-basis", "0px"),
                    A2(Ja, "min-height", "min-content"),
                    A2(Qa, _a(me), u([
                        A2(Ja, "flex-basis", "auto")
                    ]))
                ])),
                A2(Ca, _a($e), u([
                    A2(Ja, "flex-grow", "100000")
                ])),
                A2(Ca, _a(Te), u([
                    A2(Ja, "width", "100%")
                ])),
                A2(Ca, _a(Ge), u([
                    A2(Ja, "width", "100%")
                ])),
                A2(Ca, _a(qe), u([
                    A2(Ja, "align-self", "flex-start")
                ])),
                A2(Ca, "u:first-of-type." + te, u([
                    A2(Ja, "flex-grow", "1")
                ])),
                A2(Ca, "s:first-of-type." + ae, u([
                    A2(Ja, "flex-grow", "1"),
                    A2(Ca, _a(re), u([
                        A2(Ja, "margin-top", "auto !important"),
                        A2(Ja, "margin-bottom", "0 !important")
                    ]))
                ])),
                A2(Ca, "s:last-of-type." + ae, u([
                    A2(Ja, "flex-grow", "1"),
                    A2(Ca, _a(re), u([
                        A2(Ja, "margin-bottom", "auto !important"),
                        A2(Ja, "margin-top", "0 !important")
                    ]))
                ])),
                A2(Ca, "s:only-of-type." + ae, u([
                    A2(Ja, "flex-grow", "1"),
                    A2(Ca, _a(re), u([
                        A2(Ja, "margin-top", "auto !important"),
                        A2(Ja, "margin-bottom", "auto !important")
                    ]))
                ])),
                A2(Ca, "s:last-of-type.accy ~ u", u([
                    A2(Ja, "flex-grow", "0")
                ])),
                A2(Ca, "u:first-of-type.acb ~ s." + ae, u([
                    A2(Ja, "flex-grow", "0")
                ])),
                Ua(function(n) {
                    switch(n){
                        case 0:
                            return p(u([
                                A2(Ja, "justify-content", "flex-start")
                            ]), u([
                                A2(Ja, "margin-bottom", "auto")
                            ]));
                        case 1:
                            return p(u([
                                A2(Ja, "justify-content", "flex-end")
                            ]), u([
                                A2(Ja, "margin-top", "auto")
                            ]));
                        case 2:
                            return p(u([
                                A2(Ja, "align-items", "flex-end")
                            ]), u([
                                A2(Ja, "align-self", "flex-end")
                            ]));
                        case 3:
                            return p(u([
                                A2(Ja, "align-items", "flex-start")
                            ]), u([
                                A2(Ja, "align-self", "flex-start")
                            ]));
                        case 4:
                            return p(u([
                                A2(Ja, "align-items", "center")
                            ]), u([
                                A2(Ja, "align-self", "center")
                            ]));
                        default:
                            return p(u([
                                A2(Ja, "justify-content", "center")
                            ]), t);
                    }
                }),
                A2(Ca, _a(le), u([
                    A2(Ja, "flex-grow", "0"),
                    A2(Ja, "flex-basis", "auto"),
                    A2(Ja, "width", "100%"),
                    A2(Ja, "align-self", "stretch !important")
                ])),
                A2(Qa, _a("sev"), u([
                    A2(Ja, "justify-content", "space-between")
                ]))
            ])),
            A2(Qa, _a("g"), u([
                A2(Ja, "display", "-ms-grid"),
                A2(Ca, ".gp", u([
                    A2(Ca, _a(oe), u([
                        A2(Ja, "width", "100%")
                    ]))
                ])),
                A2(Ra, p("display", "grid"), u([
                    p("display", "grid")
                ])),
                (rt = function(n) {
                    switch(n){
                        case 0:
                            return u([
                                A2(Ja, "justify-content", "flex-start")
                            ]);
                        case 1:
                            return u([
                                A2(Ja, "justify-content", "flex-end")
                            ]);
                        case 2:
                            return u([
                                A2(Ja, "align-items", "flex-end")
                            ]);
                        case 3:
                            return u([
                                A2(Ja, "align-items", "flex-start")
                            ]);
                        case 4:
                            return u([
                                A2(Ja, "align-items", "center")
                            ]);
                        default:
                            return u([
                                A2(Ja, "justify-content", "center")
                            ]);
                    }
                }, Ga(A2(Wa, function(n) {
                    return u([
                        A2(Ca, _a(oe), u([
                            A2(Qa, Va(n), rt(n))
                        ]))
                    ]);
                }, Ha)))
            ])),
            A2(Qa, _a(Le), u([
                A2(Ja, "display", "block"),
                A2(Ca, _a("s:first-child"), u([
                    A2(Ja, "margin", "0 !important")
                ])),
                A2(Ca, _a(oe + (Va(3) + ":first-child + .") + oe), u([
                    A2(Ja, "margin", "0 !important")
                ])),
                A2(Ca, _a(oe + (Va(2) + ":first-child + .") + oe), u([
                    A2(Ja, "margin", "0 !important")
                ])),
                Ua(function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 4:
                        default:
                            return p(t, t);
                        case 2:
                            return p(t, u([
                                A2(Ja, "float", "right"),
                                A2(Qa, "::after", u([
                                    A2(Ja, "content", '""'),
                                    A2(Ja, "display", "table"),
                                    A2(Ja, "clear", "both")
                                ]))
                            ]));
                        case 3:
                            return p(t, u([
                                A2(Ja, "float", "left"),
                                A2(Qa, "::after", u([
                                    A2(Ja, "content", '""'),
                                    A2(Ja, "display", "table"),
                                    A2(Ja, "clear", "both")
                                ]))
                            ]));
                    }
                })
            ])),
            A2(Qa, _a("iml"), u([
                A2(Ja, "white-space", "pre-wrap !important"),
                A2(Ja, "height", "100%"),
                A2(Ja, "width", "100%"),
                A2(Ja, "background-color", "transparent")
            ])),
            A2(Qa, _a(ze), u([
                A2(Qa, _a(Ke), u([
                    A2(Ja, "flex-basis", "auto")
                ]))
            ])),
            A2(Qa, _a(je), u([
                A2(Ja, "white-space", "pre-wrap !important"),
                A2(Ja, "cursor", "text"),
                A2(Ca, _a(ke), u([
                    A2(Ja, "white-space", "pre-wrap !important"),
                    A2(Ja, "color", "transparent")
                ]))
            ])),
            A2(Qa, _a(Se), u([
                A2(Ja, "display", "block"),
                A2(Ja, "white-space", "normal"),
                A2(Ja, "overflow-wrap", "break-word"),
                A2(Qa, _a("hbh"), u([
                    A2(Ja, "z-index", "0"),
                    A2(Ca, _a(fe), u([
                        A2(Ja, "z-index", "-1")
                    ]))
                ])),
                A2(Ta, _a(Ie), u([
                    A2(Ja, "display", "inline"),
                    A2(Ja, "white-space", "normal")
                ])),
                A2(Ta, _a(Se), u([
                    A2(Ja, "display", "inline"),
                    A2(Qa, "::after", u([
                        A2(Ja, "content", "none")
                    ])),
                    A2(Qa, "::before", u([
                        A2(Ja, "content", "none")
                    ]))
                ])),
                A2(Ta, _a(Ke), u([
                    A2(Ja, "display", "inline"),
                    A2(Ja, "white-space", "normal"),
                    A2(Qa, _a(Me), u([
                        A2(Ja, "display", "inline-block")
                    ])),
                    A2(Qa, _a(xe), u([
                        A2(Ja, "display", "flex")
                    ])),
                    A2(Qa, _a(fe), u([
                        A2(Ja, "display", "flex")
                    ])),
                    A2(Qa, _a("a"), u([
                        A2(Ja, "display", "flex")
                    ])),
                    A2(Qa, _a("b"), u([
                        A2(Ja, "display", "flex")
                    ])),
                    A2(Qa, _a(Ae), u([
                        A2(Ja, "display", "flex")
                    ])),
                    A2(Qa, _a(Fe), u([
                        A2(Ja, "display", "flex")
                    ])),
                    A2(Ca, _a(Ie), u([
                        A2(Ja, "display", "inline"),
                        A2(Ja, "white-space", "normal")
                    ]))
                ])),
                A2(Ca, _a(Ne), u([
                    A2(Ja, "display", "inline")
                ])),
                A2(Ca, _a(se), u([
                    A2(Ja, "display", "inline-flex")
                ])),
                A2(Ca, _a("g"), u([
                    A2(Ja, "display", "inline-grid")
                ])),
                Ua(function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 4:
                        default:
                            return p(t, t);
                        case 2:
                            return p(t, u([
                                A2(Ja, "float", "right")
                            ]));
                        case 3:
                            return p(t, u([
                                A2(Ja, "float", "left")
                            ]));
                    }
                })
            ])),
            A2(Qa, ".hidden", u([
                A2(Ja, "display", "none")
            ])),
            A2(Qa, _a("w1"), u([
                A2(Ja, "font-weight", "100")
            ])),
            A2(Qa, _a("w2"), u([
                A2(Ja, "font-weight", "200")
            ])),
            A2(Qa, _a("w3"), u([
                A2(Ja, "font-weight", "300")
            ])),
            A2(Qa, _a("w4"), u([
                A2(Ja, "font-weight", "400")
            ])),
            A2(Qa, _a("w5"), u([
                A2(Ja, "font-weight", "500")
            ])),
            A2(Qa, _a("w6"), u([
                A2(Ja, "font-weight", "600")
            ])),
            A2(Qa, _a("w7"), u([
                A2(Ja, "font-weight", "700")
            ])),
            A2(Qa, _a("w8"), u([
                A2(Ja, "font-weight", "800")
            ])),
            A2(Qa, _a("w9"), u([
                A2(Ja, "font-weight", "900")
            ])),
            A2(Qa, _a("i"), u([
                A2(Ja, "font-style", "italic")
            ])),
            A2(Qa, _a("sk"), u([
                A2(Ja, "text-decoration", "line-through")
            ])),
            A2(Qa, _a("u"), u([
                A2(Ja, "text-decoration", "underline"),
                A2(Ja, "text-decoration-skip-ink", "auto"),
                A2(Ja, "text-decoration-skip", "ink")
            ])),
            A2(Qa, g(_a("u"), _a("sk")), u([
                A2(Ja, "text-decoration", "line-through underline"),
                A2(Ja, "text-decoration-skip-ink", "auto"),
                A2(Ja, "text-decoration-skip", "ink")
            ])),
            A2(Qa, _a("tun"), u([
                A2(Ja, "font-style", "normal")
            ])),
            A2(Qa, _a("tj"), u([
                A2(Ja, "text-align", "justify")
            ])),
            A2(Qa, _a("tja"), u([
                A2(Ja, "text-align", "justify-all")
            ])),
            A2(Qa, _a("tc"), u([
                A2(Ja, "text-align", "center")
            ])),
            A2(Qa, _a("tr"), u([
                A2(Ja, "text-align", "right")
            ])),
            A2(Qa, _a("tl"), u([
                A2(Ja, "text-align", "left")
            ])),
            A2(Qa, ".modal", u([
                A2(Ja, "position", "fixed"),
                A2(Ja, "left", "0"),
                A2(Ja, "top", "0"),
                A2(Ja, "width", "100%"),
                A2(Ja, "height", "100%"),
                A2(Ja, "pointer-events", "none")
            ]))
        ]))
    ]), tu = function(n) {
        return u([
            A2(Da, ".v-" + n, u([
                A2(Ja, "font-feature-settings", '"' + n + '"')
            ])),
            A2(Da, ".v-" + n + "-off", u([
                A2(Ja, "font-feature-settings", '"' + n + '" 0')
            ]))
        ]);
    }, eu = Za(u([
        A2(Zr, function(n) {
            return A2(Da, ".border-" + sr(n), u([
                A2(Ja, "border-width", sr(n) + "px")
            ]));
        }, A2(hr, 0, 6)),
        A2(Zr, function(n) {
            return A2(Da, ".font-size-" + sr(n), u([
                A2(Ja, "font-size", sr(n) + "px")
            ]));
        }, A2(hr, 8, 32)),
        A2(Zr, function(n) {
            return A2(Da, ".p-" + sr(n), u([
                A2(Ja, "padding", sr(n) + "px")
            ]));
        }, A2(hr, 0, 24)),
        u([
            A2(Da, ".v-smcp", u([
                A2(Ja, "font-variant", "small-caps")
            ])),
            A2(Da, ".v-smcp-off", u([
                A2(Ja, "font-variant", "normal")
            ]))
        ]),
        tu("zero"),
        tu("onum"),
        tu("liga"),
        tu("dlig"),
        tu("ordn"),
        tu("tnum"),
        tu("afrc"),
        tu("frac")
    ])), au = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {" + _a(oe) + _a(Ne) + " > " + _a(oe) + " { flex-basis: auto !important; } " + _a(oe) + _a(Ne) + " > " + _a(oe) + _a(le) + ' { flex-basis: auto !important; }}\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .s {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .s {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n', uu = function(n) {
        return A2(lr, "", n);
    }, iu = F2(function(n, r) {
        return {
            aS: r,
            o: t,
            ab: t,
            M: n
        };
    }), cu = F2(function(n, r) {
        var e = n;
        return A3(Hr, F2(function(n, r) {
            switch(n.$){
                case 0:
                    return h(r, {
                        ab: A2(Yn, p(n.a, n.b), r.ab)
                    });
                case 3:
                    var a = n.a;
                    return h(r, {
                        o: A2(Yn, {
                            aS: "\n}",
                            o: t,
                            ab: n.b,
                            M: "@supports (" + a.a + ":" + a.b + ") {" + e.M
                        }, r.o)
                    });
                case 5:
                    var u = n.b;
                    return h(r, {
                        o: A2(Yn, A2(cu, A2(iu, e.M + " + " + n.a, ""), u), r.o)
                    });
                case 1:
                    var i = n.b;
                    return h(r, {
                        o: A2(Yn, A2(cu, A2(iu, e.M + " > " + n.a, ""), i), r.o)
                    });
                case 2:
                    return i = n.b, h(r, {
                        o: A2(Yn, A2(cu, A2(iu, e.M + " " + n.a, ""), i), r.o)
                    });
                case 4:
                    var c = n.b;
                    return h(r, {
                        o: A2(Yn, A2(cu, A2(iu, g(e.M, n.a), ""), c), r.o)
                    });
                default:
                    var o = n.a;
                    return h(r, {
                        o: A2(Yn, A2(cu, A2(iu, e.M, ""), o), r.o)
                    });
            }
        }), e, r);
    }), ou = g(au, (et = g(ru, eu), at = function(n) {
        return n.ab.b ? n.M + "{" + function(n) {
            return uu(A2(Zr, function(n) {
                return n.a + ":" + n.b + ";";
            }, n));
        }(n.ab) + n.aS + "}" : "";
    }, ut = function(n) {
        var r = n;
        return g(at(r), uu(A2(Zr, ut, r.o)));
    }, uu(A2(Zr, ut, A3(Hr, F2(function(n, r) {
        var t = n.b;
        return A2(Yn, A2(cu, A2(iu, n.a, ""), t), r);
    }), t, et))))), fu = fn, su = function(n) {
        switch(n.d2){
            case 0:
                return A3(qa, "div", t, u([
                    A3(qa, "style", t, u([
                        fu(ou)
                    ]))
                ]));
            case 1:
                return fu("");
            default:
                return A3(qa, "elm-ui-static-rules", u([
                    A2(Ma, "rules", De(ou))
                ]), t);
        }
    }, lu = F2(function(n, r) {
        return A3(br, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), bu = function(n) {
        switch(n.$){
            case 0:
                return "serif";
            case 1:
                return "sans-serif";
            case 2:
                return "monospace";
            case 3:
            case 4:
                return '"' + n.a + '"';
            default:
                return '"' + n.a.d3 + '"';
        }
    }, du = function(n) {
        switch(n.$){
            case 0:
                return "smcp" === n.a;
            case 1:
                return !1;
            default:
                return "smcp" === n.a && 1 === n.b;
        }
    }, pu = function(n) {
        return 5 === n.$ && A2(xt, du, n.a.cG);
    }, vu = F2(function(n, r) {
        return 0 > b(n, r) ? n : r;
    }), hu = F3(function(n, r, t) {
        var e = r.a, a = r.b;
        return n ? t + "\n  " + e + ": " + a + " !important;" : t + "\n  " + e + ": " + a + ";";
    }), gu = F4(function(n, r, e, a) {
        if (1 === r.$) return u([
            e + "{" + A3(br, hu(!1), "", a) + "\n}"
        ]);
        switch(r.a){
            case 1:
                switch(n.dK){
                    case 0:
                        return t;
                    case 2:
                        return u([
                            e + "-hv {" + A3(br, hu(!0), "", a) + "\n}"
                        ]);
                    default:
                        return u([
                            e + "-hv:hover {" + A3(br, hu(!1), "", a) + "\n}"
                        ]);
                }
            case 0:
                var i = A3(br, hu(!1), "", a);
                return u([
                    e + "-fs:focus {" + i + "\n}",
                    ".s:focus " + e + "-fs  {" + i + "\n}",
                    e + "-fs:focus-within {" + i + "\n}",
                    ".ui-slide-bar:focus + " + _a(oe) + " .focusable-thumb" + e + "-fs {" + i + "\n}"
                ]);
            default:
                return u([
                    e + "-act:active {" + A3(br, hu(!1), "", a) + "\n}"
                ]);
        }
    }), mu = function(n) {
        switch(n.$){
            case 0:
                return '"' + n.a + '"';
            case 1:
                return '"' + n.a + '" 0';
            default:
                return '"' + n.a + '" ' + sr(n.b);
        }
    }, $u = function(n) {
        return 5 === n.$ ? or(A2(lr, ", ", A2(Zr, mu, n.a.cG))) : fr;
    }, wu = F3(function(n, r, e) {
        switch(r.$){
            case 0:
                return A4(gu, n, e, r.a, r.b);
            case 13:
                return A4(gu, n, e, "." + (i = r.a), u([
                    A2(Fa, "box-shadow", r.b)
                ]));
            case 12:
                return A4(gu, n, e, "." + (i = r.a), u([
                    A2(Fa, "opacity", Nt(A2(_r, 0, A2(vu, 1, 1 - r.b))))
                ]));
            case 2:
                var a = r.a;
                return A4(gu, n, e, ".font-size-" + sr(a), u([
                    A2(Fa, "font-size", sr(a) + "px")
                ]));
            case 1:
                var i = r.a, c = r.b, o = A2(lr, ", ", A2(Sa, $u, c)), f = u([
                    A2(Fa, "font-family", A2(lr, ", ", A2(Zr, bu, c))),
                    A2(Fa, "font-feature-settings", o),
                    A2(Fa, "font-variant", A2(xt, pu, c) ? "small-caps" : "normal")
                ]);
                return A4(gu, n, e, "." + i, f);
            case 3:
                return A4(gu, n, e, "." + (q = r.a), u([
                    A2(Fa, r.b, T = r.c)
                ]));
            case 4:
                return A4(gu, n, e, "." + (q = r.a), u([
                    A2(Fa, r.b, Na(r.c))
                ]));
            case 5:
                var s = r.a, l = r.b, b = r.c, d = sr(b) + "px", v = sr(l) + "px", h = ".ar", m = ".p", $ = ".pg", w = ".al", x = Nt(b / 2) + "px", y = Nt(l / 2) + "px", k = ".s";
                return Za(u([
                    A4(gu, n, e, (q = "." + s) + ".r > " + ".s + " + k, u([
                        A2(Fa, "margin-left", v)
                    ])),
                    A4(gu, n, e, q + ".wrp.r > " + k, u([
                        A2(Fa, "margin", x + " " + y)
                    ])),
                    A4(gu, n, e, q + ".c > " + ".s + " + k, u([
                        A2(Fa, "margin-top", d)
                    ])),
                    A4(gu, n, e, q + ($ + " > ") + ".s + " + k, u([
                        A2(Fa, "margin-top", d)
                    ])),
                    A4(gu, n, e, q + ($ + " > ") + w, u([
                        A2(Fa, "margin-right", v)
                    ])),
                    A4(gu, n, e, q + ($ + " > ") + h, u([
                        A2(Fa, "margin-left", v)
                    ])),
                    A4(gu, n, e, g(q, m), u([
                        A2(Fa, "line-height", "calc(1em + " + sr(b) + "px)")
                    ])),
                    A4(gu, n, e, "textarea" + (k + q), u([
                        A2(Fa, "line-height", "calc(1em + " + sr(b) + "px)"),
                        A2(Fa, "height", "calc(100% + " + sr(b) + "px)")
                    ])),
                    A4(gu, n, e, q + ".p > " + w, u([
                        A2(Fa, "margin-right", v)
                    ])),
                    A4(gu, n, e, q + ".p > " + h, u([
                        A2(Fa, "margin-left", v)
                    ])),
                    A4(gu, n, e, q + ".p::after", u([
                        A2(Fa, "content", "''"),
                        A2(Fa, "display", "block"),
                        A2(Fa, "height", "0"),
                        A2(Fa, "width", "0"),
                        A2(Fa, "margin-top", sr(-1 * (b / 2 | 0)) + "px")
                    ])),
                    A4(gu, n, e, q + ".p::before", u([
                        A2(Fa, "content", "''"),
                        A2(Fa, "display", "block"),
                        A2(Fa, "height", "0"),
                        A2(Fa, "width", "0"),
                        A2(Fa, "margin-bottom", sr(-1 * (b / 2 | 0)) + "px")
                    ]))
                ]));
            case 7:
                h = r.c;
                var j = r.d;
                return w = r.e, A4(gu, n, e, q = "." + (s = r.a), u([
                    A2(Fa, "padding", Nt(r.b) + "px " + Nt(h) + "px " + Nt(j) + "px " + Nt(w) + "px")
                ]));
            case 6:
                return h = r.c, j = r.d, w = r.e, A4(gu, n, e, q = "." + (s = r.a), u([
                    A2(Fa, "border-width", sr(r.b) + "px " + sr(h) + "px " + sr(j) + "px " + sr(w) + "px")
                ]));
            case 8:
                var z = r.a, E = F3(function(n, r, t) {
                    n: for(;;)switch(t.$){
                        case 0:
                            return sr(t.a) + "px";
                        case 1:
                            var e = p(n, r);
                            if (1 === e.a.$) return 1 === e.b.$ ? "max-content" : "minmax(max-content, " + sr(a = e.b.a) + "px)";
                            if (1 === e.b.$) return "minmax(" + sr(e.a.a) + "px, max-content)";
                            var a = e.b.a;
                            return "minmax(" + sr(e.a.a) + "px, " + sr(a) + "px)";
                        case 2:
                            var u = t.a, i = p(n, r);
                            return 1 === i.a.$ ? 1 === i.b.$ ? sr(u) + "fr" : "minmax(max-content, " + sr(a = i.b.a) + "px)" : 1 === i.b.$ ? "minmax(" + sr(i.a.a) + "px, " + sr(u) + "frfr)" : (a = i.b.a, "minmax(" + sr(i.a.a) + "px, " + sr(a) + "px)");
                        case 3:
                            var c = t.b;
                            n = or(t.a), t = c;
                            continue n;
                        default:
                            c = t.b, r = or(t.a), t = c;
                            continue n;
                    }
                }), B = function(n) {
                    return A3(E, fr, fr, n);
                }, F = (B(z.eE.a), B(z.eE.b)), A = function(n) {
                    return "grid-template-rows: " + n + ";";
                }(A2(lr, " ", A2(Zr, B, z.ev))), _ = function(n) {
                    return "-ms-grid-rows: " + n + ";";
                }(A2(lr, F, A2(Zr, B, z.Q))), L = function(n) {
                    return "-ms-grid-columns: " + n + ";";
                }(A2(lr, F, A2(Zr, B, z.Q))), S = "grid-row-gap:" + B(z.eE.b) + ";", N = "grid-column-gap:" + B(z.eE.a) + ";", K = function(n) {
                    return "grid-template-columns: " + n + ";";
                }(A2(lr, " ", A2(Zr, B, z.Q)));
                return u([
                    (q = ".grid-rows-" + A2(lr, "-", A2(Zr, da, z.ev)) + "-cols-" + A2(lr, "-", A2(Zr, da, z.Q)) + "-space-x-" + da(z.eE.a) + "-space-y-" + da(z.eE.b)) + "{" + L + _ + "}",
                    "@supports (display:grid) {" + q + "{" + K + A + N + S + "}}"
                ]);
            case 9:
                var P = r.a, I = A2(lr, " ", u([
                    "-ms-grid-row: " + sr(P.L) + ";",
                    "-ms-grid-row-span: " + sr(P.b1) + ";",
                    "-ms-grid-column: " + sr(P.dp) + ";",
                    "-ms-grid-column-span: " + sr(P.cL) + ";"
                ])), O = A2(lr, " ", u([
                    "grid-row: " + sr(P.L) + " / " + sr(P.L + P.b1) + ";",
                    "grid-column: " + sr(P.dp) + " / " + sr(P.dp + P.cL) + ";"
                ]));
                return u([
                    (q = ".grid-pos-" + sr(P.L) + "-" + sr(P.dp) + "-" + sr(P.cL) + "-" + sr(P.b1)) + "{" + I + "}",
                    "@supports (display:grid) {" + q + "{" + O + "}}"
                ]);
            case 11:
                var q = r.a;
                return A2(Wa, function(r) {
                    return A3(wu, n, r, or(q));
                }, r.b);
            default:
                var M = r.a, T = function(n) {
                    switch(n.$){
                        case 0:
                            return fr;
                        case 1:
                            var r = n.a, t = r.b, e = r.c;
                            return or("translate3d(" + Nt(r.a) + "px, " + Nt(t) + "px, " + Nt(e) + "px)");
                        default:
                            var a = n.a, u = a.b, i = a.c, c = n.b, o = c.a, f = c.b, s = c.c, l = n.c, b = l.a, d = l.b, p = l.c, v = n.d, h = "translate3d(" + Nt(a.a) + "px, " + Nt(u) + "px, " + Nt(i) + "px)", g = "scale3d(" + Nt(o) + ", " + Nt(f) + ", " + Nt(s) + ")", m = "rotate3d(" + Nt(b) + ", " + Nt(d) + ", " + Nt(p) + ", " + Nt(v) + "rad)";
                            return or(h + " " + g + " " + m);
                    }
                }(M), G = p(q = ha(M), T);
                return G.a.$ || G.b.$ ? t : A4(gu, n, e, "." + (s = G.a.a), u([
                    A2(Fa, "transform", G.b.a)
                ]));
        }
    }), xu = F2(function(n, r) {
        var t;
        return t = A2(Zr, function(r) {
            var t = A3(wu, n, r, fr);
            return p(ga(r), A2(lu, De, t));
        }, r), A3(br, F2(function(n, r) {
            return A3(T, n.a, n.b, r);
        }), {}, t);
    }), yu = F2(function(n, r) {
        return n + " {" + A2(lr, "", A2(Zr, function(n) {
            return n.a + ": " + n.b + ";";
        }, r)) + "}";
    }), ku = F3(function(n, r, t) {
        var e = t.b;
        return u([
            A2(yu, "." + n + "." + r + ", ." + n + " ." + r, t.a),
            A2(yu, "." + n + "." + r + "> ." + "t, ." + n + " ." + r + " > ." + Ie, e)
        ]);
    }), ju = F3(function(n, r, t) {
        var e = r.a, a = r.b, u = s(n, t) ? n : t + " ." + n;
        return A2(lr, " ", g(A3(ku, u, Pe, a), A3(ku, u, "fs", e)));
    }), zu = F2(function(n, r) {
        var t = s(n, r) ? n : r + " ." + n;
        return A2(lr, " ", u([
            A2(yu, "." + t + "." + Pe + ", ." + t + " ." + Pe, u([
                p("line-height", "1")
            ])),
            A2(yu, "." + t + "." + Pe + "> ." + "t, ." + t + " ." + Pe + " > ." + Ie, u([
                p("vertical-align", "0"),
                p("line-height", "1")
            ]))
        ]));
    }), Eu = F3(function(n, r, t) {
        return {
            b1: r / n,
            al: n,
            cH: t
        };
    }), Bu = F2(function(n, r) {
        return A3(Hr, F2(function(r, t) {
            return n(r) ? A2(Yn, r, t) : t;
        }), t, r);
    }), Fu = function(n) {
        return n.b ? or(A3(br, vu, n.a, n.b)) : fr;
    }, Au = function(n) {
        var r = u([
            n.dj,
            n.c6,
            n.du,
            n.d$
        ]), t = A2(Dt, n.du, Fu(r)), e = A2(Dt, n.c6, Fu(A2(Bu, function(n) {
            return !s(n, t);
        }, r))), a = A2(Dt, n.dj, Ct(r)), i = 1 / (a - t), c = 1 - a;
        return {
            dj: A3(Eu, 1 / (a - e), a - e, 1 - a),
            bZ: A3(Eu, i, a - t, c)
        };
    }, _u = function(n) {
        return p(u([
            p("display", "block")
        ]), u([
            p("display", "inline-block"),
            p("line-height", Nt(n.b1)),
            p("vertical-align", Nt(n.cH) + "em"),
            p("font-size", Nt(n.al) + "em")
        ]));
    }, Lu = F2(function(n, r) {
        var e = A3(br, F2(function(r, t) {
            var e, a;
            return {
                a$: g(t.a$, A3(wu, n, r, fr)),
                aL: (a = 1 === (e = r).$ ? or(p(e.a, e.b)) : fr, 1 === a.$ ? t.aL : A2(Yn, a.a, t.aL))
            };
        }), {
            a$: t,
            aL: t
        }, r), a = e.a$;
        return g(function(n) {
            var r = function(n) {
                return 4 === n.$ ? or("@import url('" + n.b + "');") : fr;
            }, t = function(n) {
                return A2(lr, "\n", A2(Sa, r, n.b));
            }, e = A2(Zr, Nr, n), a = function(n) {
                var r, t = n.a, a = (r = n.b, A3(br, F2(function(n, r) {
                    if (1 === r.$) {
                        if (5 === n.$) {
                            var t = n.a.cT;
                            if (1 === t.$) return r;
                            var e = t.a;
                            return or(p(_u(Au(e).bZ), _u(Au(e).dj)));
                        }
                        return r;
                    }
                    return r;
                }), fr, r));
                return A2(lr, "", A2(Zr, 1 === a.$ ? zu(t) : A2(ju, t, a.a), e));
            };
            return g(A2(lr, "\n", A2(Zr, t, n)), A2(lr, "\n", A2(Zr, a, n)));
        }(e.aL), uu(a));
    }), Su = F2(function(n, r) {
        switch(n.d2){
            case 0:
            case 1:
                return A3(qa, "div", t, u([
                    A3(qa, "style", t, u([
                        fu(A2(Lu, n, r))
                    ]))
                ]));
            default:
                return A3(qa, "elm-ui-rules", u([
                    A2(Ma, "rules", A2(xu, n, r))
                ]), t);
        }
    }), Nu = F4(function(n, r, t, e) {
        var a = A2(Su, r, A3(br, Ba, p(ba, Oa(r.dG)), t).b);
        return n ? A2(Yn, p("static-stylesheet", su(r)), A2(Yn, p("dynamic-stylesheet", a), e)) : A2(Yn, p("dynamic-stylesheet", a), e);
    }), Ku = F4(function(n, r, t, e) {
        var a = A2(Su, r, A3(br, Ba, p(ba, Oa(r.dG)), t).b);
        return n ? A2(Yn, su(r), A2(Yn, a, e)) : A2(Yn, a, e);
    }), Pu = aa(45), Iu = aa(37), Ou = function(n) {
        return dn(xn(n));
    }, qu = bn("p"), Mu = F2(function(n, r) {
        var t = r.a;
        if (n.$) {
            var e = n.a;
            return s(e & r.b, e);
        }
        var a = n.a;
        return s(a & t, a);
    }), Tu = bn("s"), Gu = bn("u"), Cu = aa(44), Du = aa(39), Qu = F6(function(n, r, t, e, a, i) {
        var c = F2(function(n, r) {
            if (1 === e.$) {
                var t = e.a;
                return A3(Ou, n, r, function() {
                    switch(a.$){
                        case 0:
                            return t;
                        case 2:
                            return A4(Nu, !1, a.a, a.b, t);
                        default:
                            return A4(Nu, !0, a.a, a.b, t);
                    }
                }());
            }
            var u = e.a;
            return A2(function() {
                switch(n){
                    case "div":
                        return fa;
                    case "p":
                        return qu;
                    default:
                        return qa(n);
                }
            }(), r, function() {
                switch(a.$){
                    case 0:
                        return u;
                    case 2:
                        return A4(Ku, !1, a.a, a.b, u);
                    default:
                        return A4(Ku, !0, a.a, a.b, u);
                }
            }());
        }), o = function() {
            switch(r.$){
                case 0:
                    return A2(c, "div", t);
                case 1:
                    return A2(c, r.a, t);
                default:
                    return A3(qa, r.a, t, u([
                        A2(c, r.b, u([
                            Je("s e")
                        ]))
                    ]));
            }
        }();
        switch(i){
            case 0:
                return A2(Mu, Du, n) && !A2(Mu, Cu, n) ? o : A2(Mu, ia, n) ? A2(Gu, u([
                    Je(A2(lr, " ", u([
                        oe,
                        Ke,
                        le,
                        be,
                        ue
                    ])))
                ]), u([
                    o
                ])) : A2(Mu, ca, n) ? A2(Tu, u([
                    Je(A2(lr, " ", u([
                        oe,
                        Ke,
                        le,
                        be,
                        ee
                    ])))
                ]), u([
                    o
                ])) : o;
            case 1:
                return A2(Mu, Iu, n) && !A2(Mu, Pu, n) ? o : A2(Mu, oa, n) ? A2(Tu, u([
                    Je(A2(lr, " ", u([
                        oe,
                        Ke,
                        le,
                        ae
                    ])))
                ]), u([
                    o
                ])) : A2(Mu, ua, n) ? A2(Gu, u([
                    Je(A2(lr, " ", u([
                        oe,
                        Ke,
                        le,
                        te
                    ])))
                ]), u([
                    o
                ])) : o;
            default:
                return o;
        }
    }), Ju = function(n) {
        return !n.b;
    }, Ru = fu, Hu = function(n) {
        return A2(fa, u([
            Je("s t wc hc")
        ]), u([
            Ru(n)
        ]));
    }, Zu = function(n) {
        return A2(fa, u([
            Je("s t wf hf")
        ]), u([
            Ru(n)
        ]));
    }, Wu = F3(function(n, r, e) {
        var a = F2(function(r, t) {
            var e = r.a, a = r.b, u = t.a, i = t.b;
            switch(a.$){
                case 0:
                    var c = a.a;
                    return s(n, 4), p(A2(Yn, p(e, c(n)), u), i);
                case 1:
                    var o = a.a;
                    return s(n, 4), p(A2(Yn, p(e, A2(o.dL, Xe, n)), u), Ju(i) ? o.cB : g(o.cB, i));
                case 2:
                    var f = a.a;
                    return p(A2(Yn, p(e, s(n, 2) ? Zu(f) : Hu(f)), u), i);
                default:
                    return p(u, i);
            }
        }), u = F2(function(r, t) {
            var e = t.a, a = t.b;
            switch(r.$){
                case 0:
                    var u = r.a;
                    return s(n, 4), p(A2(Yn, u(n), e), a);
                case 1:
                    var i = r.a;
                    return s(n, 4), p(A2(Yn, A2(i.dL, Xe, n), e), Ju(a) ? i.cB : g(i.cB, a));
                case 2:
                    var c = r.a;
                    return p(A2(Yn, s(n, 2) ? Zu(c) : Hu(c), e), a);
                default:
                    return p(e, a);
            }
        });
        if (1 === r.$) {
            var i = r.a, c = A3(Hr, a, p(t, t), i), o = c.a;
            if ((b = Ju(l = c.b) ? e.cB : g(e.cB, l)).b) {
                var f = b;
                return na({
                    dL: A4(Qu, e.ag, e.ci, e.aP, Ue(A3(ea, "nearby-element-pls", o, e.dl))),
                    cB: f
                });
            }
            return ra(A5(Qu, e.ag, e.ci, e.aP, Ue(A3(ea, "nearby-element-pls", o, e.dl)), Xe));
        }
        var l, b, d = r.a, v = A3(Hr, u, p(t, t), d), h = v.a;
        return (b = Ju(l = v.b) ? e.cB : g(e.cB, l)).b ? (f = b, na({
            dL: A4(Qu, e.ag, e.ci, e.aP, We(A2(ta, h, e.dl))),
            cB: f
        })) : ra(A5(Qu, e.ag, e.ci, e.aP, We(A2(ta, h, e.dl)), Xe));
    }), Yu = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), Vu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Uu = F2(function(n, r) {
        var t = r.a, e = r.b;
        return n.$ ? A2(Vu, t, n.a | e) : A2(Vu, n.a | t, e);
    }), Xu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ni = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ri = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ti = F2(function(n, r) {
        return A2(fa, u([
            Je(function() {
                switch(n){
                    case 0:
                        return A2(lr, " ", u([
                            Ee,
                            Ke,
                            "a"
                        ]));
                    case 1:
                        return A2(lr, " ", u([
                            Ee,
                            Ke,
                            "b"
                        ]));
                    case 2:
                        return A2(lr, " ", u([
                            Ee,
                            Ke,
                            Ae
                        ]));
                    case 3:
                        return A2(lr, " ", u([
                            Ee,
                            Ke,
                            Fe
                        ]));
                    case 4:
                        return A2(lr, " ", u([
                            Ee,
                            Ke,
                            xe
                        ]));
                    default:
                        return A2(lr, " ", u([
                            Ee,
                            Ke,
                            fe
                        ]));
                }
            }())
        ]), u([
            function() {
                switch(r.$){
                    case 3:
                        return fu("");
                    case 2:
                        return Hu(r.a);
                    case 0:
                        return (0, r.a)(2);
                    default:
                        return A2(r.a.dL, Xe, 2);
                }
            }()
        ]));
    }), ei = F3(function(n, r, t) {
        var e = A2(ti, n, r);
        switch(t.$){
            case 0:
                return 5 === n ? Xu(u([
                    e
                ])) : ri(u([
                    e
                ]));
            case 1:
                var a = t.a;
                return 5 === n ? Xu(A2(Yn, e, a)) : A2(ni, a, u([
                    e
                ]));
            case 2:
                var i = t.a;
                return 5 === n ? A2(ni, u([
                    e
                ]), i) : ri(A2(Yn, e, i));
            default:
                return a = t.a, i = t.b, 5 === n ? A2(ni, A2(Yn, e, a), i) : A2(ni, a, A2(Yn, e, i));
        }
    }), ai = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ui = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ii = F2(function(n, r) {
        switch(r.$){
            case 0:
                return ui(n);
            case 1:
                return A2(ai, r.a, n);
            default:
                return A2(ai, r.a, r.b);
        }
    }), ci = function(n) {
        switch(n){
            case 0:
                return "ah al";
            case 2:
                return "ah ar";
            default:
                return "ah cx";
        }
    }, oi = function(n) {
        switch(n){
            case 0:
                return "av at";
            case 2:
                return "av ab";
            default:
                return "av cy";
        }
    }, fi = F2(function(n, r) {
        return A2(gn, function(n) {
            return $n.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return wn.test(n) ? "" : n;
        }(r));
    }), si = F4(function(n, r, t, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), li = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bi = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch(r.$){
                    case 0:
                        return li(v(a = r.a, 0, 0));
                    case 1:
                        return li(v(0, u = r.a, 0));
                    case 2:
                        return li(v(0, 0, i = r.a));
                    case 3:
                        return li(t = r.a);
                    case 4:
                        var t = r.a, e = r.b;
                        return A4(si, v(0, 0, 0), v(1, 1, 1), t, e);
                    default:
                        return t = r.a, A4(si, v(0, 0, 0), t, v(0, 0, 1), 0);
                }
            case 1:
                var a = (c = n.a).a, u = c.b, i = c.c;
                switch(r.$){
                    case 0:
                        return li(v(r.a, u, i));
                    case 1:
                        return li(v(a, r.a, i));
                    case 2:
                        return li(v(a, u, r.a));
                    case 3:
                        return li(t = r.a);
                    case 4:
                        return t = r.a, e = r.b, A4(si, c, v(1, 1, 1), t, e);
                    default:
                        return A4(si, c, r.a, v(0, 0, 1), 0);
                }
            default:
                a = (c = n.a).a, u = c.b, i = c.c;
                var c, o = n.b, f = n.c;
                switch(e = n.d, r.$){
                    case 0:
                        return A4(si, v(r.a, u, i), o, f, e);
                    case 1:
                        return A4(si, v(a, r.a, i), o, f, e);
                    case 2:
                        return A4(si, v(a, u, r.a), o, f, e);
                    case 3:
                        return A4(si, r.a, o, f, e);
                    case 4:
                        return A4(si, c, o, r.a, r.b);
                    default:
                        return A4(si, c, r.a, f, e);
                }
        }
    }), di = aa(7), pi = aa(36), vi = F2(function(n, r) {
        return A2(Vu, n.a | r.a, n.b | r.b);
    }), hi = A2(Vu, 0, 0), gi = function(n) {
        switch(n.$){
            case 0:
                var r = sr(n.a), e = "height-px-" + r;
                return v(hi, "he " + e, u([
                    A3(Yu, e, "height", r + "px")
                ]));
            case 1:
                return v(A2(Uu, pi, hi), ge, t);
            case 2:
                var a = n.a;
                return 1 === a ? v(A2(Uu, Iu, hi), $e, t) : v(A2(Uu, Iu, hi), we + " height-fill-" + sr(a), u([
                    A3(Yu, "s.c > " + _a("height-fill-" + sr(a)), "flex-grow", sr(1e5 * a))
                ]));
            case 3:
                var i = n.a, c = n.b, o = "min-height-" + sr(i), f = A3(Yu, o, "min-height", sr(i) + "px !important"), s = gi(c), l = s.b, b = s.c;
                return v(A2(Uu, Pu, s.a), o + " " + l, A2(Yn, f, b));
            default:
                var d = n.a, p = (c = n.b, o = "max-height-" + sr(d), f = A3(Yu, o, "max-height", sr(d) + "px"), gi(c));
                return l = p.b, b = p.c, v(A2(Uu, Pu, p.a), o + " " + l, A2(Yn, f, b));
        }
    }, mi = aa(38), $i = function(n) {
        switch(n.$){
            case 0:
                var r = n.a;
                return v(hi, "we width-px-" + sr(r), u([
                    A3(Yu, "width-px-" + sr(r), "width", sr(r) + "px")
                ]));
            case 1:
                return v(A2(Uu, mi, hi), qe, t);
            case 2:
                var e = n.a;
                return 1 === e ? v(A2(Uu, Du, hi), Te, t) : v(A2(Uu, Du, hi), Ge + " width-fill-" + sr(e), u([
                    A3(Yu, "s.r > " + _a("width-fill-" + sr(e)), "flex-grow", sr(1e5 * e))
                ]));
            case 3:
                var a = n.a, i = n.b, c = "min-width-" + sr(a), o = A3(Yu, c, "min-width", sr(a) + "px"), f = $i(i), s = f.b, l = f.c;
                return v(A2(Uu, Cu, f.a), c + " " + s, A2(Yn, o, l));
            default:
                var b = n.a, d = (i = n.b, c = "max-width-" + sr(b), o = A3(Yu, c, "max-width", sr(b) + "px"), $i(i));
                return s = d.b, l = d.c, v(A2(Uu, Cu, d.a), c + " " + s, A2(Yn, o, l));
        }
    }, wi = aa(27), xi = F2(function(n, r) {
        if (s(n, wi)) {
            if (3 !== r.$) return !1;
            switch(r.c){
                case "0px":
                case "1px":
                case "2px":
                case "3px":
                case "4px":
                case "5px":
                case "6px":
                    return !0;
                default:
                    return !1;
            }
        } else switch(r.$){
            case 2:
                var t = r.a;
                return t >= 8 && 32 >= t;
            case 7:
                var e = r.b, a = r.c, u = r.e;
                return s(e, r.d) && s(e, a) && s(e, u) && e >= 0 && 24 >= e;
            default:
                return !1;
        }
    }), yi = aa(6), ki = aa(30), ji = aa(29), zi = F8(function(n, r, t, e, a, u, i, c) {
        n: for(;;){
            if (!c.b) {
                var o = ha(e);
                return 1 === o.$ ? {
                    aP: A2(Yn, Je(n), u),
                    dl: i,
                    ag: t,
                    ci: r,
                    cB: a
                } : {
                    aP: A2(Yn, Je(n + " " + o.a), u),
                    dl: i,
                    ag: t,
                    ci: r,
                    cB: A2(Yn, (I = e, {
                        $: 10,
                        a: I
                    }), a)
                };
            }
            var f = c.a, s = c.b;
            switch(f.$){
                case 0:
                    n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                    continue n;
                case 3:
                    var l = f.b;
                    if (A2(Mu, d = f.a, t)) {
                        n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    n = h = l + " " + n, r = m = r, t = $ = A2(Uu, d, t), e = w = e, a = x = a, c = s;
                    continue n;
                case 1:
                    n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, u = A2(Yn, f.a, u), c = s;
                    continue n;
                case 4:
                    var b = f.b;
                    if (A2(Mu, d = f.a, t)) {
                        n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    if (A2(xi, d, b)) {
                        n = h = ga(b) + " " + n, r = m = r, t = $ = A2(Uu, d, t), e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    n = h = ga(b) + " " + n, r = m = r, t = $ = A2(Uu, d, t), e = w = e, a = x = A2(Yn, b, a), c = s;
                    continue n;
                case 10:
                    var d, p = f.b;
                    n = h = n, r = m = r, t = $ = A2(Uu, d = f.a, t), e = w = A2(bi, e, p), a = x = a, c = s;
                    continue n;
                case 7:
                    var v = f.a;
                    if (A2(Mu, yi, t)) {
                        n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    switch(v.$){
                        case 0:
                            var h = "we width-px-" + sr(z = v.a) + " " + n, m = r, $ = A2(Uu, yi, t), w = e, x = A2(Yn, A3(Yu, "width-px-" + sr(z), "width", sr(z) + "px"), a);
                            n = h, r = m, t = $, e = w, a = x, c = s;
                            continue n;
                        case 1:
                            n = h = n + " " + qe, r = m = r, t = $ = A2(Uu, mi, A2(Uu, yi, t)), e = w = e, a = x = a, c = s;
                            continue n;
                        case 2:
                            if (1 === (F = v.a)) {
                                n = h = n + " " + Te, r = m = r, t = $ = A2(Uu, Du, A2(Uu, yi, t)), e = w = e, a = x = a, c = s;
                                continue n;
                            }
                            h = n + " " + Ge + " width-fill-" + sr(F), m = r, $ = A2(Uu, Du, A2(Uu, yi, t)), w = e, x = A2(Yn, A3(Yu, "s.r > " + _a("width-fill-" + sr(F)), "flex-grow", sr(1e5 * F)), a), n = h, r = m, t = $, e = w, a = x, c = s;
                            continue n;
                        default:
                            var y = $i(v), k = y.c;
                            h = n + " " + y.b, m = r, $ = A2(vi, y.a, A2(Uu, yi, t)), w = e, x = g(k, a), n = h, r = m, t = $, e = w, a = x, c = s;
                            continue n;
                    }
                case 8:
                    var j = f.a;
                    if (A2(Mu, di, t)) {
                        n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    switch(j.$){
                        case 0:
                            var z, E = sr(z = j.a) + "px", B = "height-px-" + E;
                            n = h = "he " + B + " " + n, r = m = r, t = $ = A2(Uu, di, t), e = w = e, a = x = A2(Yn, A3(Yu, B, "height ", E), a), c = s;
                            continue n;
                        case 1:
                            n = h = "hc " + n, r = m = r, t = $ = A2(Uu, pi, A2(Uu, di, t)), e = w = e, a = x = a, c = s;
                            continue n;
                        case 2:
                            var F;
                            if (1 === (F = j.a)) {
                                n = h = "hf " + n, r = m = r, t = $ = A2(Uu, Iu, A2(Uu, di, t)), e = w = e, a = x = a, c = s;
                                continue n;
                            }
                            h = n + " " + we + " height-fill-" + sr(F), m = r, $ = A2(Uu, Iu, A2(Uu, di, t)), w = e, x = A2(Yn, A3(Yu, "s.c > " + _a("height-fill-" + sr(F)), "flex-grow", sr(1e5 * F)), a), n = h, r = m, t = $, e = w, a = x, c = s;
                            continue n;
                        default:
                            var A = gi(j);
                            k = A.c, h = n + " " + A.b, m = r, $ = A2(vi, A.a, A2(Uu, di, t)), w = e, x = g(k, a), n = h, r = m, t = $, e = w, a = x, c = s;
                            continue n;
                    }
                case 2:
                    var _ = f.a;
                    switch(_.$){
                        case 0:
                            n = h = n, r = m = A2(ii, "main", r), t = $ = t, e = w = e, a = x = a, c = s;
                            continue n;
                        case 1:
                            n = h = n, r = m = A2(ii, "nav", r), t = $ = t, e = w = e, a = x = a, c = s;
                            continue n;
                        case 2:
                            n = h = n, r = m = A2(ii, "footer", r), t = $ = t, e = w = e, a = x = a, c = s;
                            continue n;
                        case 3:
                            n = h = n, r = m = A2(ii, "aside", r), t = $ = t, e = w = e, a = x = a, c = s;
                            continue n;
                        case 4:
                            var L = _.a;
                            if (L > 1) {
                                if (7 > L) {
                                    n = h = n, r = m = A2(ii, "h" + sr(L), r), t = $ = t, e = w = e, a = x = a, c = s;
                                    continue n;
                                }
                                n = h = n, r = m = A2(ii, "h6", r), t = $ = t, e = w = e, a = x = a, c = s;
                                continue n;
                            }
                            n = h = n, r = m = A2(ii, "h1", r), t = $ = t, e = w = e, a = x = a, c = s;
                            continue n;
                        case 9:
                            n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                            continue n;
                        case 8:
                            n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, u = A2(Yn, A2(fi, "role", "button"), u), c = s;
                            continue n;
                        case 5:
                            n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, u = A2(Yn, A2(fi, "aria-label", _.a), u), c = s;
                            continue n;
                        case 6:
                            n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, u = A2(Yn, A2(fi, "aria-live", "polite"), u), c = s;
                            continue n;
                        default:
                            n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, u = A2(Yn, A2(fi, "aria-live", "assertive"), u), c = s;
                            continue n;
                    }
                case 9:
                    var S = f.a, N = f.b;
                    k = function() {
                        switch(N.$){
                            case 3:
                            case 2:
                            case 0:
                                return a;
                            default:
                                return g(a, N.a.cB);
                        }
                    }(), n = h = n, r = m = r, t = $ = t, e = w = e, a = x = k, i = A3(ei, S, N, i), c = s;
                    continue n;
                case 6:
                    var K = f.a;
                    if (A2(Mu, ki, t)) {
                        n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    n = h = ci(K) + " " + n, r = m = r, t = $ = function(n) {
                        switch(K){
                            case 1:
                                return A2(Uu, ca, n);
                            case 2:
                                return A2(Uu, ia, n);
                            default:
                                return n;
                        }
                    }(A2(Uu, ki, t)), e = w = e, a = x = a, c = s;
                    continue n;
                default:
                    var P = f.a;
                    if (A2(Mu, ji, t)) {
                        n = h = n, r = m = r, t = $ = t, e = w = e, a = x = a, c = s;
                        continue n;
                    }
                    n = h = oi(P) + " " + n, r = m = r, t = $ = function(n) {
                        switch(P){
                            case 1:
                                return A2(Uu, oa, n);
                            case 2:
                                return A2(Uu, ua, n);
                            default:
                                return n;
                        }
                    }(A2(Uu, ji, t)), e = w = e, a = x = a, c = s;
                    continue n;
            }
        }
        var I;
    }), Ei = {
        $: 0
    }, Bi = F4(function(n, r, e, a) {
        return A3(Wu, n, a, A8(zi, function(n) {
            switch(n){
                case 0:
                    return "s r";
                case 1:
                    return "s c";
                case 2:
                    return "s e";
                case 3:
                    return "s g";
                case 4:
                    return "s p";
                default:
                    return "s pg";
            }
        }(n), r, hi, Ei, t, t, Ve, mr(e)));
    }), Fi = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ai = {
        c3: fr,
        db: fr,
        eA: or({
            ap: 0,
            aq: A4(Fi, 155 / 255, 203 / 255, 1, 1),
            cj: p(0, 0),
            al: 3
        })
    }, _i = F2(function(n, r) {
        switch(r.$){
            case 0:
                return (0, r.a)(2);
            case 1:
                return A2(r.a.dL, n(r.a.cB), 2);
            case 2:
                return Hu(r.a);
            default:
                return Hu("");
        }
    }), Li = F3(function(n, r, t) {
        var e = function(n) {
            var r, t, e, a;
            return {
                dG: (a = (r = A3(Hr, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return 1 === r.dK.$ ? h(r, {
                                dK: or(n.a)
                            }) : r;
                        case 1:
                            return 1 === r.dG.$ ? h(r, {
                                dG: or(n.a)
                            }) : r;
                        default:
                            return 1 === r.d2.$ ? h(r, {
                                d2: or(n.a)
                            }) : r;
                    }
                }), {
                    dG: fr,
                    dK: fr,
                    d2: fr
                }, n)).dG, 1 === a.$ ? Ai : a.a),
                dK: (e = r.dK, 1 === e.$ ? 1 : e.a),
                d2: (t = r.d2, 1 === t.$ ? 0 : t.a)
            };
        }(n), a = 1 === e.d2 ? He(e) : Ze(e);
        return A2(_i, a, A4(Bi, 2, Ye, r, We(u([
            t
        ]))));
    }), Si = F3(function(n, r, t) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t
        };
    }), Ni = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ki = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pi = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ii = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Oi = aa(8), qi = aa(14), Mi = aa(5), Ti = aa(4), Gi = function(n) {
        var r = n.b, t = n.c, e = n.d;
        return va(n.a) + "-" + va(r) + "-" + va(t) + "-" + va(e);
    }, Ci = function(n) {
        return n.toLowerCase();
    }, Di = function(n) {
        return u(n.trim().split(/\s+/g));
    }, Qi = F2(function(n, r) {
        return g(r, function() {
            switch(n.$){
                case 0:
                    return "serif";
                case 1:
                    return "sans-serif";
                case 2:
                    return "monospace";
                case 3:
                case 4:
                    return A2(lr, "-", Di(Ci(n.a)));
                default:
                    return A2(lr, "-", Di(Ci(n.a.d3)));
            }
        }());
    }), Ji = (it = u([
        Ii("Open Sans"),
        Ii("Helvetica"),
        Ii("Verdana"),
        {
            $: 1
        }
    ]), u([
        A2(Pi, Oi, A3(Si, "bg-" + Gi(A4(Fi, 1, 1, 1, 0)), "background-color", A4(Fi, 1, 1, 1, 0))),
        A2(Pi, qi, A3(Si, "fc-" + Gi(A4(Fi, 0, 0, 0, 1)), "color", A4(Fi, 0, 0, 0, 1))),
        A2(Pi, Ti, Ki(20)),
        A2(Pi, Mi, A2(Ni, A3(br, Qi, "font-", it), it))
    ])), Ri = F3(function(n, r, t) {
        return A3(Li, n.ei, A2(Yn, Re(A2(lr, " ", u([
            "ui",
            oe,
            Ke
        ]))), g(Ji, r)), t);
    })({
        ei: t
    }), Hi = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Zi = Hi(1), Wi = function(n) {
        return A2(Pi, Oi, A3(Si, "bg-" + Gi(n), "background-color", n));
    }, Yi = aa(28), Vi = function(n) {
        return A2(Pi, Yi, A3(Si, "bc-" + Gi(n), "border-color", n));
    }, Ui = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Xi = {
        $: 1
    }, nc = function(n) {
        return {
            $: 7,
            a: n
        };
    }, rc = F2(function(n, r) {
        return A4(Bi, 1, Ye, A2(Yn, Re("ct cl"), A2(Yn, Ui(Xi), A2(Yn, nc(Xi), n))), We(r));
    }), tc = F2(function(n, r) {
        return A4(Bi, 2, Ye, A2(Yn, nc(Xi), A2(Yn, Ui(Xi), n)), We(u([
            r
        ])));
    }), ec = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ac = {
        $: 1
    }, uc = Hi(2), ic = gn("cursor"), cc = gn("fill"), oc = gn("font-family"), fc = gn("font-size"), sc = gn("height"), lc = F2(function(n) {
        return n;
    }), bc = A2(yt, ra, lc), dc = bc, pc = pn, vc = F2(function(n, r) {
        return A2(pc, n, {
            $: 0,
            a: r
        });
    }), hc = function(n) {
        return A2(vc, "click", Gr(n));
    }, gc = gn("points"), mc = ln("http://www.w3.org/2000/svg"), $c = mc("polygon"), wc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xc = gn("stroke"), yc = gn("stroke-width"), kc = mc("svg"), jc = fu, zc = mc("text"), Ec = gn("viewBox"), Bc = gn("width"), Fc = gn("x"), Ac = gn("y"), _c = F2(function(n, r) {
        var e = "rgb(150,150,150)", a = "rgba(0,0,0,0.8)", i = "rgb(120,150,150)", c = r.$ ? p(e, e) : r.a ? p(e, a) : p(a, e), o = c.a, f = c.b, s = r.$ ? p("transparent", "transparent") : r.a ? p("transparent", i) : p(i, "transparent"), l = s.a, b = s.b;
        return A2(tc, u([
            nc(wc(100)),
            Ui(wc(60))
        ]), dc(A2(kc, u([
            Bc("100"),
            sc("60"),
            Ec("0 0 100 60")
        ]), u([
            A2($c, u([
                gc("1,1 1,59 53,59 43,1"),
                xc("rgb(50,50,50)"),
                yc("2"),
                ic("pointer"),
                cc(l),
                hc(n(!1))
            ]), t),
            A2($c, u([
                gc("57,59 47,1 99,1 99,59"),
                xc("rgb(50,50,50)"),
                yc("2"),
                ic("pointer"),
                cc(b),
                hc(n(!0))
            ]), t),
            A2(zc, u([
                Fc("9"),
                Ac("40"),
                cc(o),
                fc("22pt"),
                oc("sans-serif"),
                ic("pointer"),
                hc(n(!1))
            ]), u([
                jc("-1")
            ])),
            A2(zc, u([
                Fc("67"),
                Ac("40"),
                cc(f),
                fc("22pt"),
                oc("sans-serif"),
                ic("pointer"),
                hc(n(!0))
            ]), u([
                jc("1")
            ]))
        ]))));
    }), Lc = function(n) {
        var r = "rgba(150,150,150,0.2)", e = "rgba(150,150,150,0.7)", a = "rgba(0,0,0,0.8)", i = "rgb(50,50,50)", c = "rgb(180,180,180)", o = n ? p(r, a) : p(a, r), f = o.a, s = o.b, l = n ? p(e, i) : p(i, e), b = l.a, d = l.b, v = n ? p("transparent", c) : p(c, "transparent"), h = v.a, g = v.b;
        return A2(tc, u([
            nc(wc(100)),
            Ui(wc(60))
        ]), dc(A2(kc, u([
            Bc("100"),
            sc("60"),
            Ec("0 0 100 60")
        ]), u([
            A2($c, u([
                gc("1,1 1,59 53,59 43,1"),
                yc("2"),
                xc(b),
                cc(h)
            ]), t),
            A2($c, u([
                gc("57,59 47,1 99,1 99,59"),
                yc("2"),
                xc(d),
                cc(g)
            ]), t),
            A2(zc, u([
                Fc("9"),
                Ac("40"),
                cc(f),
                oc("sans-serif"),
                fc("22pt")
            ]), u([
                jc("-1")
            ])),
            A2(zc, u([
                Fc("67"),
                Ac("40"),
                cc(s),
                oc("sans-serif"),
                fc("22pt")
            ]), u([
                jc("1")
            ]))
        ]))));
    }, Sc = {
        $: 8
    }, Nc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Kc = M, Pc = F2(function(n, r) {
        return A2(hn, n, Kc(r));
    }), Ic = Pc("disabled"), Oc = {
        $: 0
    }, qc = function(n) {
        return 4 === n.$ && 11 === n.b.$ && !n.b.a;
    }, Mc = A2(yt, Ce, function(n) {
        return A2(vc, "click", Gr(n));
    }), Tc = F2(function(n, r) {
        return A2(pc, n, {
            $: 2,
            a: r
        });
    }), Gc = B, Cc = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Dc = aa(21), Qc = A2(Cc, Dc, pe), Jc = F2(function(n, r) {
        var t = r.I, e = r.B;
        return A4(Bi, 2, Ye, A2(Yn, nc(Xi), A2(Yn, Ui(Xi), A2(Yn, Re("ccx ccy sbt " + Be), A2(Yn, Qc, A2(Yn, function(n) {
            return A2(xt, qc, n) ? Oc : Re("focusable");
        }(n), A2(Yn, Nc(Sc), A2(Yn, Ce(A2(gn, "tabIndex", sr(0))), function() {
            if (1 === t.$) return A2(Yn, Ce(Ic(!0)), n);
            var r, e = t.a;
            return A2(Yn, Mc(e), A2(Yn, (r = function(n) {
                return s(n, "Enter") || s(n, " ") ? or(e) : fr;
            }, Ce(A2(Tc, "keydown", A2(Tr, function(n) {
                return p(n, !0);
            }, A2(Mr, function(n) {
                var t = r(n);
                return 1 === t.$ ? function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }("No key matched") : Gr(t.a);
            }, A2(ft, "key", Gc)))))), n));
        }()))))))), We(u([
            e
        ])));
    }), Rc = aa(12), Hc = A2(Cc, Rc, "tc"), Zc = F5(function(n, r, t, e, a) {
        return {
            $: 7,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Wc = aa(2), Yc = function(n) {
        var r = n;
        return A2(Pi, Wc, A5(Zc, "p-" + sr(n), r, r, r, r));
    }, Vc = F3(function(n, r, t) {
        return A4(Fi, n / 255, r / 255, t / 255, 1);
    }), Uc = F5(function(n, r, t, e, a) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Xc = function(n) {
        return A2(Pi, wi, A5(Uc, "b-" + sr(n), n, n, n, n));
    }, no = F2(function(n, r) {
        return u([
            Yc(function() {
                switch(n){
                    case 0:
                    default:
                        return 12;
                    case 1:
                    case 2:
                        return 6;
                }
            }()),
            Xc(2),
            Vi(A3(Vc, 50, 50, 50)),
            Hc,
            Wi(function() {
                if (r) return A3(Vc, 180, 180, 180);
                switch(n){
                    case 0:
                        return A3(Vc, 175, 195, 235);
                    case 1:
                        return A3(Vc, 230, 230, 240);
                    case 2:
                        return A3(Vc, 200, 170, 180);
                    default:
                        return A3(Vc, 190, 200, 180);
                }
            }())
        ]);
    }), ro = {
        $: 2,
        a: 1
    }, to = {
        $: 3
    }, eo = F4(function(n, r, t, e) {
        return "pad-" + sr(n) + "-" + sr(r) + "-" + sr(t) + "-" + sr(e);
    }), ao = function(n) {
        var r = n.P, t = n.K, e = n.E, a = n.F;
        if (s(r, t) && s(r, e) && s(r, a)) {
            var u = r;
            return A2(Pi, Wc, A5(Zc, "p-" + sr(r), u, u, u, u));
        }
        return A2(Pi, Wc, A5(Zc, A4(eo, r, t, e, a), r, t, e, a));
    }, uo = F2(function(n, r) {
        return A4(Bi, 0, Ye, A2(Yn, Re("cl " + be), A2(Yn, nc(Xi), A2(Yn, Ui(Xi), n))), We(r));
    }), io = F3(function(n, r, t) {
        if (0 > n) return t;
        var e = A2(Rt, n, t);
        if (e.b) {
            var a = e.a, u = e.b;
            return g(A2(Yt, n, t), A2(Yn, r(a), u));
        }
        return t;
    }), co = F2(function(n, r) {
        return A2(io, n, lc(r));
    }), oo = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), fo = aa(3), so = F2(function(n, r) {
        return "spacing-" + sr(n) + "-" + sr(r);
    }), lo = function(n) {
        return A2(Pi, fo, A3(oo, A2(so, n, n), n, n));
    }, bo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, po = aa(20), vo = A2(Cc, po, "cpx"), ho = aa(10), go = function(n) {
        var r = n.c0, t = n.eI;
        if (t.b) {
            if (t.b.b) return A2(Pi, ho, A3(Yu, "bg-grad-" + A2(lr, "-", A2(Yn, va(r), A2(Zr, Gi, t))), "background-image", "linear-gradient(" + A2(lr, ", ", A2(Yn, Nt(r) + "rad", A2(Zr, Na, t))) + ")"));
            var e = t.a;
            return A2(Pi, Oi, A3(Si, "bg-" + Gi(e), "background-color", e));
        }
        return Oc;
    }, mo = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), $o = F2(function(n, r) {
        return 3 === r.$ ? Oc : A2(mo, n, r);
    }), wo = function(n) {
        return A2($o, 4, n);
    }, xo = mc("line"), yo = F4(function(n, r, t, e) {
        return A4(Fi, n / 255, r / 255, t / 255, e);
    }), ko = gn("x1"), jo = gn("x2"), zo = gn("y1"), Eo = gn("y2"), Bo = F2(function(n, r) {
        var e = Nt(50 + r / A2(_r, n, 1) * 50);
        return A2(rc, u([
            nc(wc(100)),
            lo(4)
        ]), u([
            A2(tc, u([
                nc(wc(100)),
                Ui(wc(15))
            ]), dc(A2(kc, u([
                Bc("100"),
                sc("15")
            ]), u([
                A2($c, u([
                    gc("50" === e ? "48,13 48,3 52,3 52,13" : "50,13 50,3 " + e + ",3 " + e + ",13"),
                    cc("rgb(40,150,150)")
                ]), t),
                A2(xo, u([
                    ko("50"),
                    jo("50"),
                    zo("0"),
                    Eo("15"),
                    yc("2"),
                    xc("black")
                ]), t)
            ])))),
            A2(tc, u([
                nc(wc(100)),
                Ui(wc(18)),
                A2(Pi, Ti, Ki(18)),
                vo,
                wo(A2(tc, u([
                    nc(wc(12)),
                    Ui(ro),
                    uc,
                    go({
                        c0: 1.5707963267948966,
                        eI: u([
                            A4(yo, 0, 0, 0, 0),
                            A3(Vc, 255, 255, 255)
                        ])
                    })
                ]), to))
            ]), bo(Nt(r)))
        ]));
    }), Fo = F2(function(n, r) {
        return A2(Pi, wi, A5(Uc, "b-" + sr(n) + "-" + sr(r), r, n, r, n));
    }), Ao = function(n) {
        var r = n.E, t = n.P, e = n.F, a = n.K;
        return s(t, r) && s(e, a) ? s(t, a) ? Xc(t) : A2(Fo, e, t) : A2(Pi, wi, A5(Uc, "b-" + sr(t) + "-" + sr(a) + "-" + sr(r) + "-" + sr(e), t, a, r, e));
    }, _o = F3(function(n, r, t) {
        var e = t._ + Et(A2(Zr, function(n) {
            return n.cJ * zt(n.b6);
        }, t.S)) >= 0, a = A2(Dt, 0, Ct(A2(Zr, It, A2(Yn, t._, A2(Zr, function(n) {
            return n.cJ;
        }, t.S)))));
        return A2(rc, u([
            nc(ro),
            lo(12)
        ]), u([
            A2(uo, u([
                nc(ro),
                ao({
                    E: 10,
                    F: 0,
                    K: 0,
                    P: 0
                })
            ]), u([
                A2(Jc, A2(no, 1, !1), {
                    B: bo("Back to setup"),
                    I: or(ec(ac))
                })
            ])),
            A2(uo, u([
                nc(ro),
                lo(12)
            ]), u([
                A2(tc, u([
                    nc(ro),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("inputs")),
                A2(tc, u([
                    nc(wc(100)),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("offset")),
                A2(tc, u([
                    nc(wc(100)),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("output"))
            ])),
            A2(uo, u([
                nc(ro),
                lo(12)
            ]), A2(St, A2(Zr, function(n) {
                return A2(Bo, a, n.cJ);
            }, t.S), u([
                A2(tc, u([
                    uc
                ]), A2(Bo, a, t._)),
                A2(tc, u([
                    nc(wc(100))
                ]), to)
            ]))),
            A2(uo, u([
                nc(ro),
                lo(12)
            ]), A2(St, A2(gr, F2(function(n, r) {
                return A2(_c, function(e) {
                    var a = h(r, {
                        b6: e
                    }), u = h(t, {
                        S: A3(co, n, a, t.S)
                    });
                    return ec({
                        $: 0,
                        a: u
                    });
                }, or(r.b6));
            }), t.S), u([
                A2(tc, u([
                    uc
                ]), Lc(!0)),
                A2(tc, u([
                    uc
                ]), Lc(e))
            ])))
        ]));
    }), Lo = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), So = F2(function(n, r) {
        return A2(Lo, n, r);
    }), No = F2(function(n, r) {
        if (s(n, r)) {
            var t = n;
            return A2(Pi, Wc, A5(Zc, "p-" + sr(n), t, t, t, t));
        }
        var e = r, a = n;
        return A2(Pi, Wc, A5(Zc, "p-" + sr(n) + "-" + sr(r), e, a, e, a));
    }), Ko = {
        $: 0
    }, Po = {
        $: 6
    }, Io = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Oo = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    })(1), qo = {
        $: 2
    }, Mo = {
        $: 0
    }, To = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Go = function(n) {
        return n.b ? or(n.a) : fr;
    }, Co = F2(function(n, r) {
        return 0 > n ? fr : Go(A2(Rt, n, r));
    }), Do = F3(function(n, r, e) {
        var a;
        return A2(uo, u([
            nc(ro),
            lo(12)
        ]), u([
            A2(_c, function(t) {
                var e = A2(Co, r, n.ae);
                if (e.$) return Mo;
                var a = h(e.a, {
                    aF: or(t)
                });
                return Io(To(h(n, {
                    ae: A3(co, r, a, n.ae)
                })));
            }, e.aF),
            A2(uo, u([
                nc(ro),
                lo(4)
            ]), Za(u([
                A2(gr, F2(function(t, e) {
                    return A2(_c, function(e) {
                        var a = A2(Co, r, n.ae);
                        if (a.$) return Mo;
                        var u = a.a, i = h(u, {
                            S: A3(co, t, or(e), u.S)
                        });
                        return Io(To(h(n, {
                            ae: A3(co, r, i, n.ae)
                        })));
                    }, e);
                }), e.S),
                r ? t : u([
                    A2(Jc, A2(no, 3, !1), {
                        B: bo("+ input"),
                        I: or(Io(qo))
                    })
                ]),
                u([
                    A2(Jc, g(u([
                        uc
                    ]), A2(no, 2, !1)), {
                        B: bo("- entry"),
                        I: or(Io((a = r, {
                            $: 1,
                            a: a
                        })))
                    })
                ])
            ])))
        ]));
    }), Qo = {
        $: 1
    }, Jo = Nc({
        $: 6
    }), Ro = F3(function(n, r, t) {
        if (1 === r.$) return A4(Bi, 1, ui("label"), n, We(u([
            t
        ])));
        var e = r.a, a = A4(Bi, 2, Ye, r.b, We(u([
            r.c
        ])));
        switch(e){
            case 2:
                return A4(Bi, 1, ui("label"), A2(Yn, Re(ye), n), We(u([
                    a,
                    t
                ])));
            case 3:
                return A4(Bi, 1, ui("label"), A2(Yn, Re(ye), n), We(u([
                    t,
                    a
                ])));
            case 0:
                return A4(Bi, 0, ui("label"), A2(Yn, Re(ye), n), We(u([
                    t,
                    a
                ])));
            default:
                return A4(Bi, 0, ui("label"), A2(Yn, Re(ye), n), We(u([
                    a,
                    t
                ])));
        }
    }), Ho = A2(yt, Ce, fi("autocomplete")), Zo = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), Wo = aa(26), Yo = function(n) {
        var r, t = A3(Hr, F2(function(n, r) {
            return 4 === n.$ && 5 === n.b.$ && 1 === r.$ ? or(n.b.c) : r;
        }), fr, n);
        return 1 === t.$ ? Oc : (r = Fr(t.a / 2), A2(Zo, Wo, {
            $: 1,
            a: -r
        }));
    }, Vo = A2(Cc, po, "cp"), Uo = F3(function(n, r, t) {
        return A4(Fi, n, r, t, 1);
    }), Xo = A3(Uo, 186 / 255, 189 / 255, 182 / 255), nf = A2(No, 12, 12), rf = aa(17), tf = A3(Uo, 1, 1, 1), ef = u([
        nf,
        A2(Pi, rf, A3(Yu, "br-" + sr(3), "border-radius", sr(3) + "px")),
        Vi(Xo),
        Wi(tf),
        Xc(1),
        lo(5),
        nc(ro),
        Ui(Xi)
    ]), af = function(n) {
        return 8 === n.$ ? or(n.a) : fr;
    }, uf = function(n) {
        n: for(;;)switch(n.$){
            case 1:
                return !1;
            case 0:
            case 2:
            default:
                return !0;
            case 3:
                n = n.b;
                continue n;
        }
    }, cf = function(n) {
        return p(n, !0);
    }, of = F2(function(n, r) {
        return A2(pc, n, {
            $: 1,
            a: r
        });
    }), ff = A2(F2(function(n, r) {
        return A3(Hr, ft, r, n);
    }), u([
        "target",
        "value"
    ]), Gc), sf = Ce, lf = function(n) {
        n: for(;;)switch(n.$){
            case 2:
                return !0;
            case 1:
            case 0:
                return !1;
            default:
                n = n.b;
                continue n;
        }
    }, bf = F4(function(n, r, t, e) {
        return "pad-" + va(n) + "-" + va(r) + "-" + va(t) + "-" + va(e);
    }), df = vn, pf = F4(function(n, r, t, e) {
        switch(t.$){
            case 9:
                return h(e, {
                    b: A2(Yn, t, e.b)
                });
            case 7:
                return lf(t.a) ? h(e, {
                    f: A2(Yn, t, e.f),
                    b6: A2(Yn, t, e.b6),
                    b: A2(Yn, t, e.b)
                }) : h(e, r ? {
                    f: A2(Yn, t, e.f)
                } : {
                    b: A2(Yn, t, e.b)
                });
            case 8:
                var a = t.a;
                return r ? lf(a) ? h(e, {
                    f: A2(Yn, t, e.f),
                    b: A2(Yn, t, e.b)
                }) : (function(n) {
                    n: for(;;)switch(n.$){
                        case 1:
                        case 2:
                            return !1;
                        case 0:
                            return !0;
                        default:
                            n = n.b;
                            continue n;
                    }
                }(a), h(e, {
                    b: A2(Yn, t, e.b)
                })) : h(e, {
                    f: A2(Yn, t, e.f),
                    b: A2(Yn, t, e.b)
                });
            case 6:
            case 5:
                return h(e, {
                    f: A2(Yn, t, e.f)
                });
            case 4:
                switch(t.b.$){
                    case 5:
                        return h(e, {
                            f: A2(Yn, t, e.f),
                            b6: A2(Yn, t, e.b6),
                            b: A2(Yn, t, e.b),
                            az: A2(Yn, t, e.az)
                        });
                    case 7:
                        var u = t.b, i = u.b, c = u.c, o = u.d, f = u.e;
                        if (n) return h(e, {
                            w: A2(Yn, t, e.w),
                            b: A2(Yn, t, e.b)
                        });
                        var s = i - A2(vu, i, o), l = sf(A2(df, "line-height", "calc(1.0em + " + Nt(2 * A2(vu, i, o)) + "px)")), b = sf(A2(df, "height", "calc(1.0em + " + Nt(2 * A2(vu, i, o)) + "px)")), d = o - A2(vu, i, o), p = A2(Pi, Wc, A5(Zc, A4(bf, s, c, d, f), s, c, d, f));
                        return h(e, {
                            w: A2(Yn, t, e.w),
                            b6: A2(Yn, b, A2(Yn, l, e.b6)),
                            b: A2(Yn, p, e.b)
                        });
                    case 6:
                    case 10:
                        return h(e, {
                            w: A2(Yn, t, e.w),
                            b: A2(Yn, t, e.b)
                        });
                    case 2:
                    case 1:
                        return h(e, {
                            f: A2(Yn, t, e.f)
                        });
                    default:
                        return h(e, {
                            b: A2(Yn, t, e.b)
                        });
                }
            case 0:
                return e;
            case 1:
            case 2:
                return h(e, {
                    b6: A2(Yn, t, e.b6)
                });
            case 3:
                return h(e, {
                    b: A2(Yn, t, e.b)
                });
            default:
                return h(e, {
                    b6: A2(Yn, t, e.b6)
                });
        }
    }), vf = F3(function(n, r, e) {
        var a;
        return {
            w: mr((a = A3(br, A2(pf, n, r), {
                w: t,
                f: t,
                b6: t,
                b: t,
                az: t
            }, e)).w),
            f: mr(a.f),
            b6: mr(a.b6),
            b: mr(a.b),
            az: mr(a.az)
        };
    }), hf = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), gf = aa(0), mf = A3(Uo, 136 / 255, 138 / 255, 133 / 255), $f = Fi, wf = F3(function(n, r, t) {
        var e, a, i, c = n.a, o = n.b;
        return A2(tc, g(r, g(u([
            (i = mf, A2(Pi, qi, A3(Si, "fc-" + Gi(i), "color", i))),
            Re(Be + " ppe"),
            Vo,
            Vi(A4($f, 0, 0, 0, 0)),
            Wi(A4($f, 0, 0, 0, 0)),
            Ui(ro),
            nc(ro),
            (e = t ? 1 : 0, a = 1 - A2(vu, 1, A2(_r, 0, e)), A2(Pi, gf, A2(hf, "transparency-" + va(a), a)))
        ]), c)), o);
    }), xf = A2(Cc, po, "sby"), yf = bn("span"), kf = Pc("spellcheck"), jf = A2(yt, Ce, kf), zf = Qe("type"), Ef = Qe("value"), Bf = A2(yt, Ce, Ef), Ff = F3(function(n, r, e) {
        var a, i, c, o, f, l, b, d, p, v, h, m = g(ef, r), $ = A3(vf, s(n.e3, Qo), function(n) {
            if (n.$) return !0;
            switch(n.a){
                case 0:
                case 1:
                    return !1;
                default:
                    return !0;
            }
        }(e.B), m), w = !!n.e3.$ && A2(Dt, !1, A2(Mt, uf, Go(mr(A2(Sa, af, m))))), x = A2(Dt, {
            E: 0,
            F: 0,
            K: 0,
            P: 0
        }, Go(mr(A2(Sa, function(n) {
            if (4 === n.$ && 7 === n.b.$) {
                var r = n.b, t = r.b, e = r.c, a = r.e;
                return or({
                    E: A2(_r, 0, Fr(r.d - 3)),
                    F: A2(_r, 0, Fr(a - 3)),
                    K: A2(_r, 0, Fr(e - 3)),
                    P: A2(_r, 0, Fr(t - 3))
                });
            }
            return fr;
        }, m)))), y = A4(Bi, 2, ui(n.e3.$ ? "textarea" : "input"), g(u((d = n.e3).$ ? [
            Vo,
            Ui(ro),
            Re("iml"),
            Yo(m),
            ao(x),
            Ce(A2(df, "margin", (b = x, c = {
                E: -b.E,
                F: -b.F,
                K: -b.K,
                P: -b.P
            }, o = c.K, f = c.E, l = c.F, sr(c.P) + "px " + sr(o) + "px " + sr(f) + "px " + sr(l) + "px"))),
            Ce(A2(df, "box-sizing", "content-box"))
        ] : [
            Ce(zf(d.a)),
            Re("it")
        ]), g(u([
            Bf(e.eN),
            Ce((i = e.ec, A2(of, "input", A2(Tr, cf, A2(Tr, i, ff))))),
            (a = e.B, 1 === a.$ ? Nc((h = a.a, {
                $: 5,
                a: h
            })) : Oc),
            jf(n.N),
            A2(Dt, Oc, A2(Mt, Ho, n.D))
        ]), $.b6)), We(t)), k = 1 === n.e3.$ ? A4(Bi, 2, Ye, g((w ? Yn(xf) : Dr)(u([
            nc(ro),
            A2(xt, qc, m) ? Oc : Re(he),
            Re(ze)
        ])), $.b), We(u([
            A4(Bi, 4, Ye, A2(Yn, nc(ro), A2(Yn, Ui(ro), A2(Yn, wo(y), A2(Yn, Re(je), $.az)))), We(function() {
                if ("" === e.eN) {
                    var n = e.em;
                    return u(1 === n.$ ? [
                        bo("\xa0")
                    ] : [
                        A3(wf, n.a, t, "" === e.eN)
                    ]);
                }
                return u([
                    bc(A2(yf, u([
                        Je(ke)
                    ]), u([
                        Ru(e.eN + "\xa0")
                    ])))
                ]);
            }()))
        ]))) : A4(Bi, 2, Ye, A2(Yn, nc(ro), A2(Yn, A2(xt, qc, m) ? Oc : Re(he), Za(u([
            $.b,
            (v = e.em, 1 === v.$ ? t : u([
                (p = A3(wf, v.a, $.w, "" === e.eN), A2($o, 5, p))
            ]))
        ])))), We(u([
            y
        ])));
        return A3(Ro, A2(Yn, A2(Cc, Dc, ve), A2(Yn, function(n) {
            return 1 === n.$;
        }(e.B) ? Oc : lo(5), A2(Yn, Jo, $.f))), e.B, k);
    })({
        D: fr,
        N: !1,
        e3: {
            $: 0,
            a: "text"
        }
    }), Af = F3(function(n, r, e) {
        return A2(rc, u([
            nc(ro),
            lo(16)
        ]), u([
            A2(uo, u([
                nc(ro),
                lo(12)
            ]), u([
                A2(Ff, u([
                    Wi(s(Nt(e.aO), r) ? A4(yo, 255, 255, 255, 0) : A3(Vc, 230, 180, 180)),
                    nc(wc(200))
                ]), {
                    B: A2(Oo, t, bo("μ =")),
                    ec: function(n) {
                        return Io({
                            $: 5,
                            a: n
                        });
                    },
                    em: fr,
                    eN: r
                }),
                A2(Jc, A2(St, A2(no, 0, !1), u([
                    uc
                ])), {
                    B: bo("Finish setup"),
                    I: or(Io(Po))
                })
            ])),
            A2(uo, u([
                lo(12),
                nc(ro)
            ]), u([
                A2(tc, u([
                    nc(wc(100)),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("desired")),
                A2(tc, u([
                    nc(ro),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("inputs"))
            ])),
            A2(rc, u([
                nc(ro),
                lo(4)
            ]), A2(gr, Do(e), e.ae)),
            A2(uo, u([
                lo(12)
            ]), u([
                A2(Jc, g(u([
                    nc(wc(100))
                ]), A2(no, 3, !1)), {
                    B: bo("+ entry"),
                    I: or(Io(Ko))
                }),
                A2(uo, u([
                    lo(4)
                ]), function() {
                    var n = e.ae;
                    if (n.b) {
                        var r = n.a;
                        return A2(gr, F2(function(n) {
                            var r;
                            return A2(Jc, g(u([
                                nc(wc(100))
                            ]), A2(no, 2, !1)), {
                                B: bo("- input"),
                                I: or(Io((r = n, {
                                    $: 3,
                                    a: r
                                })))
                            });
                        }), r.S);
                    }
                    return t;
                }())
            ]))
        ]));
    }), _f = {
        $: 3
    }, Lf = {
        $: 1
    }, Sf = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Nf = F2(function(n, r) {
        return A2(uo, u([
            lo(12)
        ]), A2(St, u([
            Lc(r.aF),
            Lc(!0)
        ]), A2(Zr, Lc, r.S)));
    }), Kf = F3(function(n, r, t) {
        var e, a = A2(Dt, 0, Ct(A2(Zr, It, A2(Yn, t._, t.ay))));
        return A2(rc, u([
            nc(ro),
            lo(16)
        ]), u([
            A2(uo, u([
                nc(ro),
                lo(12)
            ]), A2(St, u([
                bo("μ = " + Nt(t.aO))
            ]), u(t.at ? [
                A2(Jc, A2(St, A2(no, 0, !1), u([
                    uc
                ])), {
                    B: bo("Finish training"),
                    I: or(Sf(_f))
                })
            ] : [
                A2(Jc, A2(St, A2(no, 1, !1), u([
                    uc
                ])), {
                    B: bo("Single training step"),
                    I: or(Sf((e = 1, {
                        $: 0,
                        a: e
                    })))
                }),
                A2(Jc, A2(St, A2(no, 0, !1), u([
                    uc
                ])), {
                    B: bo("Train"),
                    I: or(Sf(Lf))
                })
            ]))),
            A2(uo, u([
                lo(12),
                nc(ro)
            ]), u([
                A2(tc, u([
                    nc(wc(100)),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("desired")),
                A2(tc, u([
                    nc(wc(100)),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("offset")),
                A2(tc, u([
                    nc(ro),
                    Ao({
                        E: 6,
                        F: 0,
                        K: 0,
                        P: 0
                    }),
                    Vi(A3(Vc, 210, 210, 210))
                ]), bo("inputs"))
            ])),
            A2(uo, u([
                nc(ro),
                lo(12)
            ]), A2(St, u([
                A2(tc, u([
                    nc(wc(100))
                ]), to),
                A2(Bo, a, t._)
            ]), A2(Zr, Bo(a), t.ay))),
            A2(rc, u([
                lo(8)
            ]), A2(Zr, Nf(t), t.ae))
        ]));
    }), Pf = function(n) {
        var r = function() {
            var r, e = n.g;
            switch(e.$){
                case 0:
                    return A2(rc, t, u([
                        A2(Jc, A2(no, 0, !1), {
                            B: bo("Begin training"),
                            I: or((r = 0, {
                                $: 1,
                                a: r
                            }))
                        })
                    ]));
                case 1:
                    return A3(Af, n, e.a, e.c);
                case 2:
                    return A3(Kf, n, e.a, e.d);
                default:
                    return A3(_o, n, e.b, e.c);
            }
        }();
        return A2(rc, u([
            nc(ro),
            lo(16)
        ]), u([
            A2(tc, u([
                nc(ro),
                Yc(16),
                Wi(A3(Vc, 180, 180, 180)),
                Ao({
                    E: 2,
                    F: 0,
                    K: 0,
                    P: 0
                }),
                Vi(A3(Vc, 50, 50, 50))
            ]), bo("Adaline")),
            A2(tc, u([
                nc(A2(So, 900, ro)),
                Zi,
                A2(No, 16, 0)
            ]), r)
        ]));
    };
    ct = {
        Main: {
            init: ot({
                dQ: function(n) {
                    return p({
                        g: nr,
                        a3: bt(n.bn)
                    }, vt);
                },
                eK: function() {
                    return gt;
                },
                e5: Xt,
                e6: function(n) {
                    return {
                        c9: u([
                            A2(Ri, t, Pf(n))
                        ]),
                        e0: function() {
                            switch(n.g.$){
                                case 0:
                                    return "Adaline";
                                case 1:
                                    return "Adaline | setup";
                                case 2:
                                    return "Adaline | training";
                                default:
                                    return "Adaline | execute";
                            }
                        }()
                    };
                }
            })(A2(Mr, function(n) {
                return Gr({
                    bn: n
                });
            }, A2(ft, "initialSeed", dt)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? f(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, ct) : n.Elm = ct;
}($a0b4f895e1596b3b$exports);


const $ad2bcec7a0192558$var$root = document.querySelector("#app div");
(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: $ad2bcec7a0192558$var$root,
    flags: {
        initialSeed: 1
    }
});


//# sourceMappingURL=index.3dfa8f9e.js.map
